module.exports = {
  messages: {
    ACTION_BLOCK_USER: 'Blockieren',
    ACTION_BLOCK_USER_DIALOG_DESCRIPTION:
      'Wenn Du {displayName} blockierst, kann Dich dieses Mitglied nicht mehr auf XING kontaktieren.',
    ACTION_BLOCK_USER_DIALOG_TITLE:
      'Möchtest Du Dein Profil für dieses Mitglied blockieren?',
    ACTION_BLOCK_USER_SUCCESS: 'Mitglied blockiert',
    ARTICLE_KIT_RECOMMEND_STREAM_PLACEHOLDER:
      'Was möchtest Du Deinen Kontakten hierzu erzählen?',
    BUTTON_ACCEPT: 'Akzeptieren',
    BUTTON_ADD: 'Hinzufügen',
    BUTTON_ADDCONTACT: 'Als Kontakt hinzufügen',
    BUTTON_BACK: 'Zurück',
    BUTTON_BACKTOP: 'zurück zur Übersicht',
    BUTTON_CANCEL: 'Abbrechen',
    BUTTON_CHANGE: 'Angaben ändern',
    BUTTON_CLEAR_FIELDS: 'Eingabe löschen',
    BUTTON_CLOSEWINDOW: 'Fenster schließen',
    BUTTON_COMMENT: 'Kommentieren',
    BUTTON_CONFIRM: 'Bestätigen',
    BUTTON_CONTINUE: 'OK',
    BUTTON_CORRECTNEWS: 'Newseintrag korrigieren',
    BUTTON_CORRECTNEWSLETTER: 'Newsletter korrigieren',
    BUTTON_CREATE_FILE: 'Aktuelle Datei erzeugen',
    BUTTON_DELCONTACT: 'Kontakt löschen',
    BUTTON_DELETE: 'Löschen',
    BUTTON_DELETE_LANGUAGE: 'Sprache löschen',
    BUTTON_EDIT: 'Bearbeiten',
    BUTTON_FILTER: 'Filtern',
    BUTTON_FORWARD: 'Weiter',
    BUTTON_FURTHER_INVITATIONS: 'Weitere Personen einladen',
    BUTTON_GRANT_PERMISSIONS: 'Zugriffsrechte erteilen',
    BUTTON_JOIN: 'Mitglied werden',
    BUTTON_JOIN_NOW: 'Jetzt Mitglied werden',
    BUTTON_LESS: 'Weniger',
    BUTTON_LOAD_MORE: 'Mehr anzeigen',
    BUTTON_MORE: 'Mehr',
    BUTTON_NEW_LANGUAGE: 'Neue Sprache',
    BUTTON_NEXT_STEP: 'Nächster Schritt',
    BUTTON_OK: 'OK',
    BUTTON_POST: 'Veröffentlichen',
    BUTTON_POST_AND_TWEET: 'Veröffentlichen & tweeten',
    BUTTON_POST_STATUS: 'Aktualisieren',
    BUTTON_PREVIEW: 'Vorschau',
    BUTTON_PRINT: 'Drucken',
    BUTTON_PUBLISH: 'Veröffentlichen',
    BUTTON_RELOAD_PAGE: 'Seite aktualisieren',
    BUTTON_SAVE: 'Speichern',
    BUTTON_SAVE_AND_CONTINUE: 'Speichern und fortsetzen',
    BUTTON_SAVENEWS: 'Newseintrag speichern',
    BUTTON_SEARCH: 'Suchen',
    BUTTON_SEND: 'Absenden',
    BUTTON_SENDMESSAGE: 'Nachricht schreiben',
    BUTTON_SENDNEWSLETTER: 'Newsletter senden',
    BUTTON_SHOW: 'Anzeigen',
    BUTTON_SHOW_ERRORS: 'Fehler anzeigen',
    BUTTON_SHOW_LESS: 'Weniger',
    BUTTON_SHOW_MORE: 'Mehr',
    BUTTON_SKIP_STEP: 'Schritt überspringen',
    BUTTON_SUBMIT: 'Bestätigen',
    BUTTON_SUGGEST: 'Kontakte vorschlagen',
    BUTTON_TEXT_RECOVERY: 'Text wiederherstellen',
    BUTTON_TRY_AGAIN: 'Noch einmal versuchen',
    BUTTON_UPDATE: 'Änderungen speichern',
    CB_POSTING_ERROR:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    COMMBOX_ACTOR_SWITCH_CANCEL: 'Absender beibehalten',
    COMMBOX_ACTOR_SWITCH_CONFIRM: 'Absender ändern',
    COMMBOX_ACTOR_SWITCH_HEADLINE:
      'Wer soll der Absender dieses Beitrags sein?',
    COMMBOX_ACTOR_SWITCH_HINT:
      'Um den Absender dieses Beitrags zu ändern, tipp einfach oben auf den Namen.',
    COMMBOX_ACTOR_SWITCH_PROMPT_IMAGE:
      'Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Bild geht dabei verloren.',
    COMMBOX_ACTOR_SWITCH_PROMPT_VIDEO:
      'Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Video geht dabei verloren.',
    COMMBOX_ACTOR_SWITCH_TYPE_PAGE: 'Eine Seite',
    COMMBOX_ACTOR_SWITCH_TYPE_USER: 'Eine Person',
    COMMBOX_ADD_PHOTO_BUTTON_LABEL: 'Foto hinzufügen',
    COMMBOX_ALMOST_FULL_FILLED_DROPZONE_HEADER:
      '1 Bild kannst Du noch hinzufügen.',
    COMMBOX_AUDIENCE_CITY_CONTACTS:
      'Nur Kontakte in meinem Arbeitsort ({totalCount})',
    COMMBOX_AUDIENCE_FOLLOWERS: 'Nur Follower',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS: 'Follower & Kontakte',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS_DESC:
      'Dein Beitrag kann geteilt werden.',
    COMMBOX_AUDIENCE_FOLLOWERS_DESC: 'Dein Beitrag kann geteilt werden.',
    COMMBOX_AUDIENCE_HEADLINE: 'Wer darf das sehen?',
    COMMBOX_AUDIENCE_PRIVATE: 'Privat (nur XING Kontakte)',
    COMMBOX_AUDIENCE_PRIVATE_DESC: 'Dein Beitrag kann nicht geteilt werden.',
    COMMBOX_AUDIENCE_PRIVATE_SELECTED: 'Privat',
    COMMBOX_AUDIENCE_PUBLIC: 'Öffentlich',
    COMMBOX_AUDIENCE_PUBLIC_DESC: 'Jeder kann Deinen Beitrag sehen und teilen.',
    COMMBOX_BUTTON_ADD_VIDEO_LABEL: 'Video hinzufügen',
    COMMBOX_BUTTON_OPEN_FILES_LABEL: 'Dokument hinzufügen',
    COMMBOX_BUTTON_OPEN_POLL_LABEL: 'Umfrage starten',
    COMMBOX_CANCEL_POSTING_BUTTON_BACK: 'Weiter bearbeiten',
    COMMBOX_CANCEL_POSTING_BUTTON_CANCEL: 'Beitrag verwerfen',
    COMMBOX_CANCEL_POSTING_HEADLINE: 'Möchtest Du den Beitrag verwerfen?',
    COMMBOX_CANCEL_POSTING_TEXT_MESSAGE: 'Deine Eingaben gehen dann verloren.',
    COMMBOX_CHARACTERS_LEFT: 'übrig',
    COMMBOX_EMPTY_DROPZONE_BUTTON_TEXT: 'Bilder auswählen',
    COMMBOX_EMPTY_DROPZONE_TEXT:
      'JPG, BMG oder PNG (max. {max_size} MB pro Bild)',
    COMMBOX_EMPTY_DROPZONE_TITLE:
      'Du kannst bis zu {max_images} Bilder hierher ziehen oder auswählen.',
    COMMBOX_EMPTY_TEXT_FIELD: 'Teil ein Foto, einen Link oder schreib was …',
    COMMBOX_EMPTY_TEXT_FIELD_MENTIONS:
      'Teil ein Foto, einen Link oder einen Gedanken (mit "@" andere erwähnen) ...',
    COMMBOX_ENTRY_POINT_LABEL: 'Eingabefeld für Deinen Beitrag',
    COMMBOX_ENTRY_POINT_TEXT: 'Was gibt’s Neues?',
    COMMBOX_FILLED_DROPZONE_HEADER:
      '{pictures} Bilder kannst Du noch hinzufügen.',
    COMMBOX_FULL_FILLED_DROPZONE_HEADER:
      'Du hast jetzt die maximale Anzahl an Fotos hinzugefügt.',
    COMMBOX_IMAGE_BUTTON_LABEL: 'Bild hinzufügen',
    COMMBOX_IMAGE_SIZE_UPLOAD_ERROR:
      'Bitte wähle ein Bild, das max. 10 MB groß ist.',
    COMMBOX_IMAGE_TYPE_UPLOAD_ERROR:
      'Bitte wähle ein Bild im JPG- oder PNG-Format.',
    COMMBOX_POLL_VOTES_NUMBER: '{votes} Stimmen',
    COMMBOX_POLLS_ADD_ANSWER_BUTTON: 'Option hinzufügen',
    'COMMBOX_POLLS_ANSWER_HELPER_LABEL.one': 'Noch ein Zeichen',
    'COMMBOX_POLLS_ANSWER_HELPER_LABEL.other': 'Noch {charsLeft} Zeichen',
    COMMBOX_POLLS_ANSWERS_PLACEHOLDER: '{optionNumber}. Option',
    COMMBOX_POLLS_ANSWERS_TITLE: 'Antwort-Optionen',
    COMMBOX_POLLS_CREATE_BUTTON_LABEL: 'Umfrage erstellen',
    COMMBOX_POLLS_DISCARD_DIALOG_MESSAGE: 'Deine Eingaben gehen dann verloren.',
    COMMBOX_POLLS_DISCARD_DIALOG_NEGATIVE_BUTTON: 'Weiter bearbeiten',
    COMMBOX_POLLS_DISCARD_DIALOG_POSITIVE_BUTTON: 'Ja, verwerfen',
    COMMBOX_POLLS_DISCARD_DIALOG_TITLE: 'Änderungen verwerfen?',
    'COMMBOX_POLLS_DURATION_LABEL.one': '%d Tag',
    'COMMBOX_POLLS_DURATION_LABEL.other': '%d Tagen',
    COMMBOX_POLLS_DURATION_TITLE: 'Dauer der Umfrage',
    COMMBOX_POLLS_ICON: 'Umfrage starten',
    'COMMBOX_POLLS_QUESTION_HELPER_ANDROID.one': 'Noch %d Zeichen',
    'COMMBOX_POLLS_QUESTION_HELPER_ANDROID.other': 'Noch %d Zeichen',
    'COMMBOX_POLLS_QUESTION_HELPER_LABEL.one': 'Noch ein Zeichen',
    'COMMBOX_POLLS_QUESTION_HELPER_LABEL.other': 'Noch %d Zeichen',
    COMMBOX_POLLS_QUESTION_PLACEHOLDER:
      'Z. B. "Wo verbringst Du Deine Mittagspause?"',
    COMMBOX_POLLS_QUESTION_TITLE: 'Deine Frage',
    COMMBOX_POLLS_SCREEN_TITLE: 'Umfrage starten',
    COMMBOX_POST: 'Teilen',
    COMMBOX_SCHEDULE: 'Fertig',
    COMMBOX_SCHEDULING_DATE: 'Datum',
    COMMBOX_SCHEDULING_DATE_FUTURE_ERROR: 'Bitte wähl ein zukünftiges Datum.',
    COMMBOX_SCHEDULING_DATE_VALIDITY_ERROR:
      'Bitte gib das Datum in diesem Format ein: "20.01.2021"',
    COMMBOX_SCHEDULING_FENCING_CTA_BUTTON: 'Alle Vorteile entdecken',
    COMMBOX_SCHEDULING_FENCING_HEADLINE: 'Beiträge planen',
    COMMBOX_SCHEDULING_FENCING_SUBLINE:
      'Legen Sie gezielt fest, wann Ihr Beitrag mit Ihren Followern geteilt wird. Durch die Planungsfunktion wird er dann automatisch zu dem Zeitpunkt veröffentlicht.',
    COMMBOX_SCHEDULING_HOUR_RECOS: 'Empfohlene Uhrzeiten',
    COMMBOX_SCHEDULING_IMMEDIATELY: 'Sofort',
    COMMBOX_SCHEDULING_NOW: 'Abbrechen',
    COMMBOX_SCHEDULING_SAVE: 'Speichern',
    COMMBOX_SCHEDULING_SCHEDULE: 'Fertig',
    COMMBOX_SCHEDULING_TIME: 'Uhrzeit',
    COMMBOX_SCHEDULING_TIME_FUTURE_ERROR:
      'Bitte wähl eine Uhrzeit, die noch nicht vorbei ist. ',
    COMMBOX_SCHEDULING_TITLE: 'Termin festlegen',
    COMMBOX_SUCCESS_ACTION: 'Beitrag ansehen',
    COMMBOX_SUCCESS_DESC: 'Dein Beitrag wurde auf XING geteilt.',
    COMMBOX_SUCCESS_HEADLINE: 'Und fertig!',
    COMMBOX_SUCCESS_SCHEDULED_DESC:
      'Dein Beitrag wird am {date} um {time} Uhr geteilt.',
    COMMBOX_UPDATE_BTN: 'Speichern',
    COMMBOX_UPLOADED_IMAGES_LIMIT_REACHED:
      'Du hast schon 10 Bilder hinzugefügt – mehr geht leider nicht.',
    COMMBOX_VIDEO_UPLOAD_ENCODING_TITLE:
      'Das Video wird gerade vorbereitet ... einen Moment Geduld bitte.',
    COMMBOX_VIDEO_UPLOAD_GENERIC_ERROR:
      'Das hat leider nicht geklappt – einfach gleich nochmal versuchen!',
    COMMBOX_VIEW_POST_BTN: 'Beitrag ansehen',
    COMMENT_BUTTON_LABEL: 'Kommentieren',
    COMPANY_BENEFIT_ACCESSIBILITY: 'Barrierefreiheit',
    COMPANY_BENEFIT_CANTEEN: 'Kantine',
    COMPANY_BENEFIT_CHILDCARE: 'Kinderbetreuung',
    COMPANY_BENEFIT_COMPANY_CAR: 'Firmenwagen',
    COMPANY_BENEFIT_COMPANY_DOCTOR: 'Betriebsarzt',
    COMPANY_BENEFIT_COMPANY_PENSION: 'Betriebliche Altersvorsorge',
    COMPANY_BENEFIT_CONVENIENT_TRANSPORT_LINKS: 'Günstige Anbindung',
    COMPANY_BENEFIT_DISCOUNTS_SPECIAL_OFFERS: 'Vorteile für Mitarbeitende',
    COMPANY_BENEFIT_DOGS_WELCOME: 'Hunde willkommen',
    COMPANY_BENEFIT_EVENTS_FOR_EMPLOYEES: 'Veranstaltungen',
    COMPANY_BENEFIT_FLEXITIME: 'Flexible Arbeitszeiten',
    COMPANY_BENEFIT_HEALTH_IN_THE_WORKPLACE: 'Gesundheitsmaßnahmen',
    COMPANY_BENEFIT_HOME_OFFICE: 'Home-Office',
    COMPANY_BENEFIT_MOBILE_DEVICE: 'Smartphone',
    COMPANY_BENEFIT_PRIVATE_INTERNET_USE: 'Privat das Internet nutzen',
    COMPANY_BENEFIT_PROFIT_SHARING: 'Gewinnbeteiligung',
    COMPANY_BENEFIT_RESTAURANT_TICKETS: 'Restaurant-Tickets',
    COMPANY_BENEFIT_TRAINING: 'Training',
    CONTENT_ACTION_BLOCK_USER: 'Blockieren',
    CONTENT_TIMESTAMP_AN_HOUR_AGO_LONG:
      '{minutesCount, plural,\n   =1 {Eben gerade}\n   other {Vor # Minuten}\n}',
    CONTENT_TIMESTAMP_DAYS_AGO_LONG:
      '{daysCount, plural,\n    =0 {Heute}\n    one {Gestern}\n    other {Vor # Tagen}\n}',
    CONTENT_TIMESTAMP_LESS_THAN_A_MINUTE_AGO: 'Gerade eben',
    CONTENT_TIMESTAMP_SOME_HOURS_AGO_LONG:
      '{hoursCount, plural,\n   =1 {Vor 1 Stunde}\n   other {Vor # Stunden}\n}',
    CONTENT_TIMESTAMP_TODAY: 'Heute',
    CONTENT_TIMESTAMP_YESTERDAY: 'Gestern',
    CP_KUNUNU_RATED_BY: '{kununu_ratings_num} Arbeitgeber-Bewertungen auf',
    CP_RECOMMENDS_ADVERTISEMENT_ABOUT_US:
      'XING empfiehlt folgende Unternehmen:',
    CROSSPOST_SHARE_ERROR:
      'Bitte nicht übertreiben. Du hast den Beitrag schon in 3 Gruppen geteilt.',
    DAY_NAMES_SHORT: 'Mo,Di,Mi,Do,Fr,Sa,So',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_CONFIRM: 'Ja, deaktivieren',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_HEADLINE: '@-Erwähnung deaktivieren?',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_TEXT:
      'Dein Name wird hier dann nicht mehr mit Deinem Profil verlinkt.',
    DUPLICATE_SHARE_ERROR:
      'Du hast dies schon geteilt – Dein Netzwerk ist also bestens informiert.',
    EP_404_ERROR:
      'Es tut uns leid: Diese Seite ist leider wie vom Winde verweht.',
    EP_404_ERROR_SUBLINE: "Aber hier gibt's garantiert was zu entdecken",
    EP_500_ERROR:
      'Hoppla! Sieht so aus, als würde unser Server gerade nicht ganz rund laufen.',
    EP_500_ERROR_SUBLINE:
      'Komm bitte in ein paar Minuten nochmal wieder. Wir arbeiten daran.',
    EP_503_ERROR: 'Offenbar haben wir gerade ein kleines Problem.',
    EP_503_ERROR_SUBLINE:
      'Einen Moment Geduld bitte, wir arbeiten schon daran.',
    EP_ABOUT_EDIT_VIEW_LABEL_INPUT_FIELD: 'Beschreibung',
    EP_ABOUT_US_DESCRIPTION: 'Über uns',
    EP_ABOUT_US_DISCOVER_CTA: 'Alle Infos ansehen',
    EP_ABOUT_US_HEADLINE: 'Über uns',
    EP_ABOUT_US_NAVIGATION_TITLE: 'Über',
    EP_ABOUT_US_SUBPAGE_EDIT_DESCRIPTION: 'Titel und Beschreibung bearbeiten',
    EP_ABOUT_US_SUBPAGE_LINK: 'Alle Infos über uns',
    EP_ADD_CONTACTS_SEARCH_LABEL: 'Ansprechperson hinzufügen',
    EP_ADD_CTA: 'Hinzufügen',
    EP_ADD_IMAGE: 'Bild hinzufügen',
    EP_ADD_MORE_COMPANIES: 'Verbindung hinzufügen',
    EP_ADD_VIDEO: 'Video hinzufügen',
    EP_ADMINISTRATE_PAGE: 'Seite verwalten',
    EP_AFFILIATES: 'Verbindungen zu anderen Unternehmen',
    EP_AFFILIATES_CATEGORY_ASSOCIATE: 'Schwester',
    EP_AFFILIATES_CATEGORY_CLIENT: 'Kunde',
    EP_AFFILIATES_CATEGORY_FRANCHISE: 'Franchise',
    EP_AFFILIATES_CATEGORY_JOINT_VENTURE: 'Joint Venture',
    EP_AFFILIATES_CATEGORY_PARENT: 'Mutter',
    EP_AFFILIATES_CATEGORY_PARTNER: 'Geschäftspartner',
    EP_AFFILIATES_CATEGORY_REGIONAL_BRANCH: 'Niederlassung',
    EP_AFFILIATES_CATEGORY_SERVICE_PROVIDER: 'Dienstleister',
    EP_AFFILIATES_CATEGORY_SUBSIDIARY: 'Tochter',
    EP_AFFILIATES_FEEDBACK_ERROR: 'Das hat leider nicht geklappt.',
    EP_AFFILIATES_NO_DATA_DESCRIPTION:
      'Also z. B. andere Firmen Ihrer Unternehmensgruppe, Ihre Dienstleister, Ihre Kunden usw.',
    EP_AFFILIATES_NO_DATA_HEADER:
      'Zeigen Sie hier, mit welchen Unternehmen Sie eine Verbindung haben.',
    EP_AFFILIATES_UPSELL_BODY:
      'Verlinken Sie auf Arbeitgeberprofile von Unternehmen, die mit Ihrem eigenen Unternehmen verbunden sind und stellen Sie Ihre Marke so umfassend dar.',
    EP_AFFILIATES_UPSELL_HEADLINE: 'Partnerprofile verknüpfen',
    EP_AFFILIATES_VALIDATION_NO_NAME_ERROR:
      'Hier bitte das Unternehmen eingeben',
    EP_AFFILIATION_TYPE: 'Art der Verbindung',
    EP_ALERT_DIALOG_FOLLOW_BTN_CANCEL: 'Abbrechen',
    EP_ALERT_DIALOG_FOLLOW_BTN_CONFIRM: 'Folgen',
    EP_ALERT_DIALOG_FOLLOW_BTN_OK: 'Alles klar',
    EP_ALERT_DIALOG_FOLLOW_INFORMATION_WEB:
      'Gute Nachricht: Du folgst {page} schon.',
    EP_ALERT_DIALOG_FOLLOW_QUESTION_WEB:
      'Du siehst die neuesten Beiträge von {page} dann immer automatisch unter Insights.',
    EP_ALERT_DIALOG_FOLLOW_TITLE_WEB: '{page} folgen?',
    EP_ALL_CONTACTS: 'Alle Ansprechpersonen',
    EP_AMOUNT_EMPLOYEES: 'Mitarbeitende',
    EP_AND: 'und',
    EP_ARMSTRONG_CREATE: 'Erstellen',
    EP_ARMSTRONG_CREATE_POST: 'Beitrag',
    EP_ARTICLES_LINK_SHARE_UNSAVED_DIALOG_LEAVE_BUTTON: 'Verlassen',
    EP_ARTICLES_LINK_SHARE_UNSAVED_DIALOG_MESSAGE:
      'Du hast noch ungespeicherte Änderungen! Möchtest du wirklich abbrechen?',
    EP_ARTICLES_LINK_SHARE_UNSAVED_DIALOG_STAY_BUTTON: 'Bleiben',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_CONFIRM_BUTTON: 'Löschen',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_DISMISS_BUTTON: 'Abbrechen',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_MESSAGE:
      'Alle Eingaben gehen dann verloren.',
    EP_ARTICLES_MODULE_DELETE_CONFIRMATION_DIALOG_TITLE: 'Artikel löschen?',
    EP_ARTICLES_MODULE_HEADLINE: 'Neuigkeiten',
    EP_ARTICLES_MODULE_PINNED_LABEL: 'Top-Artikel',
    EP_ARTICLES_MODULE_REPORT_BUTTON: 'Artikel melden',
    EP_ARTICLES_NAVIGATION_TITLE: 'Neuigkeiten',
    EP_ARTICLES_SOCIAL_COMMENTS_COUNTER_LABEL:
      '{counter, plural,\n    =1 {1 Kommentar} \n    other {# Kommentare}\n}',
    EP_ARTICLES_SOCIAL_SHARES_COUNTER_LABEL: '{counter} Geteilt',
    EP_AWARDS_CARD_ARIA_LABEL: 'Link zu den Auszeichnungen',
    EP_AWARDS_EDIT_HINT:
      'Hier werden alle Auszeichnungen gelistet, die in Ihrem kununu-Profil hinterlegt sind.',
    EP_AWARDS_HEADLINE: 'Auszeichnungen',
    EP_AWARDS_IMAGE_ALT_TEXT: 'Auszeichnung',
    EP_BACK_TO_OVERVIEW: 'Zurück zur Übersicht',
    EP_BANNER_ROLLOUT_AUTOMATIC_ROLLOUT:
      'Am 30. Nov. 2020 werden wir alle Arbeitgeberprofile ins neue Design konvertieren und alle bisherigen Daten für Sie übernehmen. Schließen Sie die Migration bereits jetzt selbst ab, um sicherzustellen, dass sich Ihre Arbeitgebermarke optimal präsentiert. Bitte beachten Sie, dass Sie nicht auf das alte Design zurück wechseln können.',
    EP_BENEFIT_ACCESSIBILITY: 'Barrierefreiheit',
    EP_BENEFIT_CANTEEN: 'Kantine',
    EP_BENEFIT_CAR_PARK: 'Parkplatz',
    EP_BENEFIT_CHILDCARE: 'Kinderbetreuung',
    EP_BENEFIT_COMPANY_CAR: 'Firmenwagen',
    EP_BENEFIT_COMPANY_DOCTOR: 'Betriebsarzt',
    EP_BENEFIT_COMPANY_PENSION: 'Betriebliche Altersvorsorge',
    EP_BENEFIT_CONVENIENT_TRANSPORT_LINKS: 'Günstige Anbindung',
    EP_BENEFIT_DISCOUNTS_SPECIAL_OFFERS: 'Rabatte',
    EP_BENEFIT_DOGS_WELCOME: 'Hunde willkommen',
    EP_BENEFIT_EVENTS_FOR_EMPLOYEES: 'Veranstaltungen',
    EP_BENEFIT_FLEXITIME: 'Flexible Arbeitszeiten',
    EP_BENEFIT_HEALTH_IN_THE_WORKPLACE: 'Gesundheitsmaßnahmen',
    EP_BENEFIT_HOME_OFFICE: 'Home-Office',
    EP_BENEFIT_MOBILE_DEVICE: 'Smartphone',
    EP_BENEFIT_PRIVATE_INTERNET_USE: 'Privat das Internet nutzen',
    EP_BENEFIT_PROFIT_SHARING: 'Gewinnbeteiligung',
    EP_BENEFIT_RESTAURANT_TICKETS: 'Restaurant-Tickets',
    EP_BENEFIT_TRAINING: 'Training',
    EP_CANCEL: 'Abbrechen',
    EP_CHANGE_IMAGE_CTA: 'Bild ändern',
    EP_CHANGE_TITLE_INFO:
      'Wollen Sie den Titel Ihrer Seite ändern? Dann schreiben Sie uns gern: <a href="mailto:customer.support@xing.com">customer.support@xing.com</a>',
    EP_CHANGE_TITLE_INFO_FREE:
      'Wollen Sie den Titel Ihrer Seite ändern? Dann schreiben Sie uns gern: <a href="mailto:arbeitgeberprofil@xing.com">arbeitgeberprofil@xing.com</a>',
    EP_CHANGE_TITLE_INFO_FREE_V2:
      'Wollen Sie den Titel Ihrer Seite ändern? Dann schreiben Sie uns gern: <a>arbeitgeberprofil@xing.com</a>',
    EP_CHANGE_TITLE_INFO_V2:
      'Wollen Sie den Titel Ihrer Seite ändern? Dann schreiben Sie uns gern: <a>customer.support@xing.com</a>',
    EP_CHOOSE_ACTION: 'Was möchtest Du tun?',
    EP_CHOOSE_COVER: 'Titelbild auswählen',
    EP_CHOOSE_COVER_INFO_BANNER: 'Tipps für ein gelungenes Titelbild',
    EP_CHOOSE_COVER_INFO_BANNER_CTA: 'Tipps lesen',
    EP_CHOOSE_LOGO:
      'Fügen Sie hier Ihr Unternehmenslogo hinzu: Damit erkennt man Ihr Unternehmen auch visuell auf einen Blick.',
    EP_CHOOSE_SECTION: 'Ändern Sie hier den Ausschnitt:',
    EP_CLEAR_ALL: 'Filter entfernen',
    EP_COMMBOX_ERROR:
      "Das hat leider nicht geklappt – versuch's bitte nochmal.",
    EP_COMMBOX_PLACEHOLDER: "Gibt's was, das Du mit anderen teilen möchtest?",
    EP_COMMBOX_POST: 'Teilen',
    EP_COMMBOX_POSTING_SUCCESSFUL_MESSAGE: 'Beitrag geteilt',
    EP_COMPANIES_AUTOMIGRATION_BANNER_CONTACT_SUPPORT:
      'Haben Sie Fragen dazu? Wir helfen Ihnen gern:\n<br/>\nE-Mail: <a href="mailto:customer.support@xing.com">customer.support@xing.com</a>\n<br/>\nTelefon: +49 40 419 131-778\n',
    EP_COMPANIES_AUTOMIGRATION_BANNER_REDIRECT_ADVISE:
      'Wenn der Link zu Ihrem alten Arbeitgeberprofil aufgerufen wird, leiten wir automatisch zur neuen XING Seite weiter.',
    EP_COMPANIES_AUTOMIGRATION_BANNER_TITLE:
      'Frischer Wind für Ihr Arbeitgeberprofil',
    EP_COMPANIES_AUTOMIGRATION_BANNER_UPDATED_URL:
      'Der Link Ihres Arbeitgeberprofil ist jetzt <strong>www.xing.com/pages/{slug}</strong>.',
    EP_COMPANIES_FEEDBACK_BANNER:
      'Dein Feedback hilft uns, das XING Employer Branding Profil für Dich zu optimieren! ',
    EP_COMPANIES_FEEDBACK_BANNER_BUTTON: 'Zur Umfrage',
    EP_COMPANY_ABOUT_US_FACTS: 'Steckbrief',
    EP_COMPANY_ABOUT_US_INDUSTRY: 'Branche',
    EP_COMPANY_INDUSTRY: 'Branche',
    EP_COMPANY_NAME: 'Unternehmensname',
    EP_COMPANY_NAME_VALIDATION_ERROR: '2-64 Zeichen kann man hier eingeben.',
    EP_COMPANY_NOT_FOUND: 'Unternehmen nicht gefunden',
    EP_COMPANY_PAGE_CREATION_ERROR:
      "Das hat leider nicht geklappt – versuchen Sie's bitte nochmal.",
    EP_COMPANY_PAGE_CREATION_INVALID_CHARACTERS_ERROR:
      'Bitte geben Sie hier nur Buchstaben und Ziffern ein, keine Sonderzeichen.',
    EP_COMPANY_PAGE_CREATION_NAME_ALREADY_USED_ERROR:
      "Für diesen Namen gibt's schon eine XING Seite. Hat sie vielleicht jemand anders aus Ihrem Unternehmen bereits erstellt? Kontaktieren Sie uns gern, wenn Sie dazu noch Fragen haben.",
    EP_COMPANY_PAGE_CREATION_NAME_HAS_ONLY_NUMBERS_ERROR:
      'Dieser Name enthält leider nur Zahlen. Bitte verwenden Sie auch Buchstaben.',
    EP_COMPANY_PAGE_CREATION_NAME_TOO_LONG_ERROR:
      'Dieser Name ist leider zu lang: Bis zu 80 Zeichen sind möglich.',
    EP_COMPANY_PAGE_CREATION_NAME_TOO_SHORT_ERROR:
      'Dieser Name ist leider zu kurz: Mindestens zwei Zeichen sind notwendig.',
    EP_COMPANY_PAGE_CREATION_STEP_1: 'Basis-Infos',
    EP_COMPANY_PAGE_CREATION_STEP_2: 'Kontaktdaten',
    EP_COMPANY_PAGE_CREATION_STEP_3: 'Unternehmenslogo',
    EP_COMPANY_PAGE_CREATION_STEP_4: 'Kurzbeschreibung',
    EP_COMPANY_RECOMMENDATIONS_HEADLINE: 'Empfehlenswerte Unternehmen',
    EP_COMPANY_RECOMMENDATIONS_NAVIGATION_TITLE: 'Ähnliche Unternehmen',
    'EP_COMPANY_SOCIAL_PROOF.one': '{username} arbeitet hier.',
    'EP_COMPANY_SOCIAL_PROOF.other':
      '{numberOfContacts} Deiner Kontakte arbeiten hier.',
    EP_COMPANY_SUMMARY: 'Steckbrief',
    EP_CONFIRMATION_LAST_STEP_CREATE_PAGE:
      '– Sobald Ihre Seite freigeschaltet ist, sagen wir Ihnen per E-Mail Bescheid (innerhalb von 72 Stunden).',
    EP_CONTACT_EDIT_LABEL: 'Beschreibung der Ansprechperson',
    EP_CONTACT_FOLLOWING: 'folgt dieser Seite.',
    EP_CONTACT_WORK: 'arbeitet hier.',
    EP_CONTACTS_CHANGE_OWNER_INFO:
      'Wenn Sie den Eigentümer dieser Seite ändern möchten, schreiben Sie uns bitte: <a href="mailto:{cs_email}">{cs_email}</a>',
    EP_CONTACTS_CHANGE_OWNER_INFO_V2:
      'Wenn Sie den Eigentümer dieser Seite ändern möchten, schreiben Sie uns bitte: <a>{cs_email}</a>',
    EP_CONTACTS_DESCRIPTION: 'Ansprechpersonen bei',
    EP_CONTACTS_EDIT_CTA: 'Ansprechpersonen bearbeiten',
    EP_CONTACTS_EDIT_TITLE: 'Ansprechpersonen bearbeiten',
    EP_CONTACTS_EMPTY_LIST:
      'Wer steht Besuchern Ihrer XING Seite für Fragen, Anregungen und Anliegen zur Verfügung? Tragen Sie diese Personen hier ein.',
    EP_CONTACTS_FOLLOWING: 'folgen dieser Seite.',
    EP_CONTACTS_HEADLINE: 'Ansprechpersonen',
    EP_CONTACTS_HIGHLIGHT_INFO:
      'Die ersten zwei Ansprechpersonen erscheinen auf der Startseite. Alle Ansprechpersonen im Überblick sind in der Rubrik "Kontakt" aufgelistet.',
    EP_CONTACTS_MESSENGER_INFO:
      'Bevor Sie jemanden als Ansprechperson hinzufügen: Stellen Sie bitte sicher, dass diese Person damit einverstanden ist. Wenn die Seite veröffentlicht wird, werden alle Ansprechpersonen darüber benachrichtigt.',
    EP_CONTACTS_MODULE_TITLE: 'Ansprechpersonen',
    EP_CONTACTS_NAVIGATION_TITLE: 'Kontakt',
    EP_CONTACTS_SEARCH_INPUT_ERROR:
      "Das hat leider nicht geklappt – versuchen Sie's einfach nochmal.",
    EP_CONTACTS_SEARCH_NO_RESULTS:
      'Diesen Namen haben wir leider nicht gefunden.',
    EP_CONTACTS_SEARCH_PLACEHOLDER: 'Namen eingeben',
    EP_CONTACTS_SUBPAGE_DESCRIPTION:
      'Alle Ansprechpersonen von {pageTitle} auf einen Blick',
    EP_CONTACTS_WORK: 'arbeiten hier.',
    EP_COVER_CROP_DESCRIPTION:
      '<b>Wichtig:</b> Bei einigen Bildschirmgrößen (z. B. auf Smartphones) ist nur die Mitte des Hintergrundbildes sichtbar. Wählen Sie deshalb ein Bild, bei dem sich die wichtigsten Elemente innerhalb der gestrichelten Linien befinden: Dieser Bereich ist nämlich immer zu sehen.',
    EP_CREATE_COMPANY_PAGE_MOBILE_INFO:
      'Bitte nutzen Sie zur Erstellung Ihrer XING Seite einen <span>großen Bildschirm</span>.',
    EP_DELETE_COVER: 'Titelbild löschen',
    EP_DELETE_COVER_DIALOG: 'Möchten Sie das Hintergrundbild wirklich löschen?',
    EP_DELETE_COVER_DIALOG_CONFIRM: 'Löschen',
    EP_DELETE_COVER_DIALOG_HEADLINE: 'Titelbild löschen?',
    EP_DELETE_COVER_DIALOG_KEEP: 'Behalten',
    EP_DELETE_DOCUMENT_DIALOG: 'Möchten Sie dieses Dokument wirklich löschen?',
    EP_DELETE_DOCUMENT_DIALOG_CANCEL: 'Abbrechen',
    EP_DELETE_DOCUMENT_DIALOG_CONFIRM: 'Ja, löschen',
    EP_DELETE_DOCUMENT_DIALOG_HEADLINE: 'Dokument löschen?',
    EP_DELETE_IMAGE_GM_DIALOG:
      'Das Bild und Ihre Eingaben dazu werden dann gelöscht.',
    EP_DELETE_IMAGE_GM_DIALOG_CANCEL: 'Abbrechen',
    EP_DELETE_IMAGE_GM_DIALOG_CONFIRM: 'Ja, löschen',
    EP_DELETE_IMAGE_GM_DIALOG_HEADLINE: 'Alles löschen?',
    EP_DELETE_VIDEO_DIALOG_CANCEL: 'Nicht löschen',
    EP_DELETE_VIDEO_DIALOG_CONFIRM: 'Ja, löschen',
    EP_DELETE_VIDEO_DIALOG_HEADLINE: 'Video löschen?',
    'EP_DELETE_VIDEO_DIALOG_HEADLINE (Copy)': 'Video löschen?',
    EP_DELETE_VIDEO_DIALOG_TEXT:
      'Dies kann nicht mehr rückgängig gemacht werden.',
    EP_DIALOG_PAGE_CREATION_CLOSE: 'Nicht beenden',
    EP_DIALOG_PAGE_CREATION_CONFIRM: 'Prozess beenden',
    EP_DISCARD_CTA: 'Verwerfen',
    EP_DISCARD_DIALOG_CANCEL: 'Abbrechen',
    EP_DISCARD_DIALOG_CONFIRM: 'Verwerfen',
    EP_DISCARD_DIALOG_HEADLINE: 'Änderungen verwerfen?',
    EP_DISCARD_DIALOG_TEXT: 'Ihre Änderungen gehen dadurch verloren.',
    EP_DISCOVER_ABOUT_US: 'Alle Infos über uns',
    EP_DISCUSSION_COMMBOX_BLOCKED_BANNER:
      'Du wurdest blockiert und kannst zur Zeit nicht an der Gruppen-Diskussion teilnehmen. Wende Dich bitte an das Moderations-Team.',
    EP_DISCUSSION_EMPTY_STATE_BODY:
      "Sobald jemand etwas veröffentlicht, siehst Du's hier.",
    EP_DISCUSSION_EMPTY_STATE_BODY_LO:
      "Sobald jemand etwas veröffentlicht, siehst Du's hier.",
    EP_DISCUSSION_EMPTY_STATE_HEADLINE: "Hier gibt's noch keine Beiträge.",
    EP_DISCUSSION_EMPTY_STATE_HEADLINE_LO: "Hier gibt's noch keine Beiträge.",
    EP_DISCUSSION_EMPTY_STATE_MODERATOR_BODY:
      'Wenn Du Deinen ersten Gruppen-Beitrag veröffentlichst, sehen Gruppen-Mitglieder, dass die Gruppe aktiv ist.',
    EP_DISCUSSION_EMPTY_STATE_MODERATOR_HEADLINE:
      'Schreib Deinen ersten Gruppen-Beitrag.',
    EP_DISCUSSION_HIDDEN_EMPTY_STATE_MODERATOR_BODY:
      'Ausgeblendete Beiträge sind nur für das Moderations-Team sichtbar, erscheinen aber nicht in der Gruppe. Klick auf das kleine Auge neben einem Beitrag, um ihn auszublenden. ',
    EP_DISCUSSION_HIDDEN_EMPTY_STATE_MODERATOR_HEADLINE:
      'Es gibt momentan keine ausgeblendeten Beiträge.',
    EP_DISCUSSION_PUBLISHED_EMPTY_STATE_MODERATOR_BODY:
      'Wenn Du Deinen ersten Gruppen-Beitrag veröffentlichst, sehen Gruppen-Mitglieder, dass die Gruppe aktiv ist.',
    EP_DISCUSSION_PUBLISHED_EMPTY_STATE_MODERATOR_HEADLINE:
      'Veröffentliche Deinen ersten Gruppen-Beitrag.',
    EP_DISCUSSIONS_DELETE_POST: 'Diesen Beitrag löschen?',
    EP_DISCUSSIONS_DELETE_POST_POPUP_BODY:
      'Dies kann nicht mehr rückgängig gemacht werden.',
    EP_DISCUSSIONS_DELETE_POST_POPUP_CTA_CANCEL: 'Abbrechen',
    EP_DISCUSSIONS_DELETE_POST_POPUP_CTA_DELETE: 'Löschen',
    EP_DISCUSSIONS_DESCRIPTION: 'Diskussionen',
    EP_DISCUSSIONS_EDIT_ALL: 'Alle Beiträge',
    'EP_DISCUSSIONS_EDIT_ALL (Copy)': 'Alle Beiträge',
    EP_DISCUSSIONS_HEADLINE: 'Diskussionen',
    EP_DISCUSSIONS_HIDE_POST: 'Beitrag ausblenden',
    EP_DISCUSSIONS_HIDE_POST_ERROR:
      'Das hat leider gerade nicht geklappt. Versuch es bitte noch einmal.',
    EP_DISCUSSIONS_HIDE_POST_POPUP_BODY:
      'Dann ist er für die Gruppe nicht mehr sichtbar.',
    EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_CANCEL: 'Abbrechen',
    EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_HIDE: 'Ausblenden',
    EP_DISCUSSIONS_HIDE_POST_POPUP_CTA_UNHIDE: 'Wieder einblenden',
    EP_DISCUSSIONS_HIDE_POST_POPUP_HEADLINE: 'Beitrag ausblenden?',
    EP_DISCUSSIONS_MARK_POST: 'Beitrag oben anpinnen',
    EP_DISCUSSIONS_NAVIGATION_TITLE: 'Diskussionen',
    EP_DISCUSSIONS_REPORT_POST: 'Beitrag melden',
    EP_DISCUSSIONS_UNHIDE_POST: 'Wieder einblenden',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_BODY:
      'Der Beitrag ist dann wieder unter "Diskussionen" in Deiner Gruppe sichtbar.',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_CTA_CANCEL: 'Abbrechen',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_CTA_HIDE: 'Wieder einblenden',
    EP_DISCUSSIONS_UNHIDE_POST_POPUP_HEADLINE:
      'Diesen Beitrag wieder einblenden?',
    EP_DOCUMENT_TITLE_EDIT_ERROR:
      'Bitte hier den Titel des Dokumentes eingeben',
    EP_DOCUMENT_TITLE_EDIT_HINT:
      'Fügen Sie hier den Titel Ihres Dokuments hinzu.',
    EP_DOCUMENT_TITLE_EDIT_LABEL: 'Titel des Dokuments',
    EP_DOCUMENTS_HEADLINE: 'Dokumente',
    EP_DONE_CTA: 'Fertig',
    EP_DRAFT_LAST_STEP_CREATE_PAGE:
      '– Bitte beachten Sie, dass sich Ihr Arbeitgeberprofil bis zur Genehmigung im Entwurfsmodus befindet und bis dahin noch nicht veröffentlicht ist.',
    EP_DRAFT_REPUBLISH_CTA: 'Veröffentlichen',
    EP_DRAFT_REPUBLISH_DESCRIPTION:
      'Die Beschwerde über diese Seite wurde zurückgewiesen – sie kann also wieder veröffentlicht werden.',
    EP_DUMMY_COMMBOX_PLACEHOLDER: 'Etwas mit anderen teilen…',
    EP_EDIT_ABOUT_DATA_TITLE: 'Eingaben bearbeiten',
    EP_EDIT_ABOUTMETA_CTA: 'Infos bearbeiten',
    EP_EDIT_ABOUTUS_COPY_TO_INTRO:
      'Als Kurzbeschreibung die ersten Zeilen der ausführlichen Beschreibung anzeigen',
    EP_EDIT_ABOUTUS_DESCRIPTION: 'Kurzbeschreibung',
    EP_EDIT_ABOUTUS_DESCRIPTION_DISCARD: 'Abbrechen',
    EP_EDIT_ABOUTUS_DESCRIPTION_PUBLISH: 'Speichern',
    EP_EDIT_ABOUTUS_DETAILED_REQUIRED:
      'Bitte fügen Sie jetzt noch den Text Ihrer "Über uns"-Rubrik hinzu.',
    EP_EDIT_ABOUTUS_EXTERNALVIDEO_INFO:
      'Videos, die Sie per Link eingebunden haben, können bald nicht mehr angezeigt werden. Laden Sie deshalb jetzt Ihre Videos direkt auf XING hoch – und fügen Sie auf Wunsch auch Untertitel und Vorschaubilder hinzu.',
    EP_EDIT_ABOUTUS_HINT:
      '<b>Tipp:</b> Nenne hier Eure wichtigsten Produkte bzw. Dienstleistungen. Benutze dabei Begriffe, die Eure Zielgruppe auch benutzt – so ist die Seite bei Google & Co. besser auffindbar.\nDu kannst hier eine Detailbeschreibung und optional eine Kurzbeschreibung eingeben. Verzichtest Du auf die Kurzbeschreibung, werden automatisch die erste Sätze der Detailbeschreibung angezeigt.',
    EP_EDIT_ABOUTUS_INDUSTRIES_INTRO:
      'Zu welcher Branche gehört Ihr Unternehmen? Geben Sie hier bis zu 5 passende Branchen ein, damit Ihre Seite besser gefunden wird und wir sie den richtigen Mitgliedern vorschlagen können.',
    EP_EDIT_ABOUTUS_INTRO_DESCRIPTION: 'Kurzbeschreibung',
    EP_EDIT_ABOUTUS_INTRO_DESCRIPTION_LABEL: 'Kurzbeschreibung',
    EP_EDIT_ABOUTUS_INTRO_INFO_TEXT:
      'Diese Kurzbeschreibung erscheint in der Übersicht unter "Über uns" – und auch bei Google & Co. in den Suchergebnissen.',
    EP_EDIT_ABOUTUS_INTRO_TITLE: 'Überschrift',
    EP_EDIT_ABOUTUS_INTRO_TITLE_LABEL: 'Überschrift',
    EP_EDIT_ABOUTUS_NAV_DESCRIPTION: 'Ausführliche Beschreibung',
    EP_EDIT_ABOUTUS_NAV_FACTS: 'Steckbrief',
    EP_EDIT_ABOUTUS_NAV_INDUSTRIES: 'Branchen',
    EP_EDIT_ABOUTUS_NAV_INTRO: 'Kurzbeschreibung',
    EP_EDIT_ABOUTUS_SUMMARY: 'Über uns: Eckdaten',
    EP_EDIT_ACTION_CONTENT_PERMISSIONS: 'Berechtigungen',
    EP_EDIT_ACTION_DISCARD: 'Abbrechen',
    EP_EDIT_ACTION_POST: 'Beitrag schreiben',
    EP_EDIT_ACTION_PROMOTE: 'Seite bewerben',
    EP_EDIT_ACTION_PUBLISH: 'Fertig',
    EP_EDIT_ACTION_SET_EDIT_MODE_OFF: 'Zur Besucheransicht',
    EP_EDIT_ACTION_SET_EDIT_MODE_ON: 'Seite bearbeiten',
    EP_EDIT_ACTION_WRITE_ARTICLE: 'Artikel schreiben',
    EP_EDIT_AFFILIATES: 'Verbindungen bearbeiten',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_BODY:
      'Möchten Sie "{companyName}" als verbundenes Unternehmen entfernen?',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_BODY_MARKUP:
      'Möchten Sie <strong>"{companyName}"</strong> als verbundenes Unternehmen entfernen?',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_CANCEL: 'Abbrechen',
    EP_EDIT_AFFILIATES_CONFIRM_DIALOG_CONFIRM: 'Ja, entfernen',
    EP_EDIT_AFFILIATES_DESCRIPTION:
      'Fügen Sie hier verwandte Unternehmen sowie Kunden, Dienstleister usw. hinzu. Voraussetzung ist, dass diese Unternehmen ebenfalls eine XING Seite haben. Wir empfehlen Ihnen zudem, sich ihrer Zustimmung zu versichern, auf Ihrer Seite als "verbundenes Unternehmen" zu erscheinen.',
    EP_EDIT_AFFILIATES_INFO:
      'Fügen Sie hier z. B. Tochter- oder Schwesterunternehmen hinzu – aber auch Kunden, Dienstleister usw. Wichtig: Diese Unternehmen müssen ebenfalls eine XING Seite haben und sollten der Verknüpfung vorher zugestimmt haben.',
    EP_EDIT_BACK_GALLERY: 'Zur Galerie',
    EP_EDIT_COMPANY_FACTS_TITLE: 'Steckbrief',
    EP_EDIT_COMPANYSIZEID: 'Mitarbeitende',
    EP_EDIT_COMPANYSIZEID_FIELD_LABEL: 'Mitarbeitende',
    EP_EDIT_CONTACTS: 'Kontakt bearbeiten',
    EP_EDIT_CONTACTS_DELETE:
      'Möchten Sie diese Ansprechperson wirklich entfernen?',
    EP_EDIT_CONTACTS_DELETE_CANCEL_CONFIRM: 'Entfernen',
    EP_EDIT_CONTACTS_DELETE_CANCEL_CTA: 'Abbrechen',
    EP_EDIT_CONTACTS_DELETED: 'Ansprechperson entfernt',
    EP_EDIT_CONTACTS_DESCRIPTION_INPUT_FIELD:
      'Tipp: Gib hier an, für welche Themen diese Ansprechperson zuständig ist.',
    EP_EDIT_CONTACTS_FREE_INFO:
      'Hier tragen Sie ein, an wen sich Besucher Ihrer XING Seite bei Fragen oder Anliegen wenden können. Wenn Sie diese Ansprechperson ändern wollen, fügen Sie einfach eine neue Person hinzu: Die bisherige wird dann automatisch entfernt. (Bei einer kostenlosen XING Seite kann man leider nur eine Ansprechperson eintragen.)',
    EP_EDIT_CONTACTS_NAV_CONTACTS: 'Kontakt',
    EP_EDIT_CONTACTS_NAV_LOCATION: 'Standort',
    EP_EDIT_CONTACTS_PAID_INFO:
      'Hier tragen Sie ein, an wen sich Besucher·innen Ihrer XING Seite bei Fragen oder Anliegen wenden können. Die ersten beiden Ansprechpersonen in dieser Liste erscheinen nicht nur auf der Detailseite "Ansprechpersonen", sondern auch auf der Übersicht Ihrer XING Seite.',
    EP_EDIT_DOCUMENTS: 'Dokumente bearbeiten',
    EP_EDIT_EVENT_ALL_LINK: 'Alle Events',
    EP_EDIT_EVENT_COPY_EVENT: 'Event kopieren',
    EP_EDIT_EVENT_DRAFT_MESSAGE_BODY:
      "Sobald Du bereit bist, kannst Du's veröffentlichen und die ersten Gäste dazu einladen. Dadurch finden auch neue Leute in Deine Gruppe.",
    EP_EDIT_EVENT_DRAFT_MESSAGE_CTA: 'Zum Event-Entwurf',
    EP_EDIT_EVENT_DRAFT_MESSAGE_HEADLINE:
      'Zeit, Deiner Gruppe vom nächsten Event zu erzählen! ',
    EP_EDIT_EVENT_EDIT_EVENTS: 'Events verwalten',
    EP_EDIT_EVENT_EMPTY_STATE_BODY:
      'Events zum Kennenlernen und Austauschen helfen Dir beim Aufbau Deiner Gruppe und Deinen Mitgliedern dabei, sich zu vernetzen und wirklich etwas für sich mitzunehmen.',
    EP_EDIT_EVENT_EMPTY_STATE_CTA: 'Gruppen-Event organisieren',
    EP_EDIT_EVENT_EMPTY_STATE_FAQ_LINK:
      'Hier findest Du Tipps für Dein Gruppen-Event.',
    EP_EDIT_EVENT_EMPTY_STATE_HEADLINE:
      'Versammle Deine Gruppe und finde neue Mitglieder – online und vor Ort.',
    EP_EDIT_EVENT_ORGANISE_CTA: 'Event organisieren',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_BODY:
      'Regelmäßige Treffen fördern den Austausch untereinander und locken auch immer wieder neue Leute in Deine Gruppe.',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_CTA: 'Event kopieren',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_HEADLINE: 'Zeit fürs nächste Gruppen-Event?',
    EP_EDIT_EVENT_PAST_EMPTY_STATE_TIP:
      'Tipp: Spar Zeit, indem Du Dein letztes Event kopierst.',
    'EP_EDIT_EVENT_PAST_TITLE.one': 'Vergangene Events',
    'EP_EDIT_EVENT_PAST_TITLE.other': 'Vergangene Events',
    'EP_EDIT_EVENT_PAST_TITLE.zero': 'Vergangene Events',
    EP_EDIT_EVENT_SUBPAGE_BACK_LINK: 'Zurück zur Übersicht',
    EP_EDIT_EVENT_SUBPAGE_COPY_EVENT_BUTTON: 'Event kopieren',
    EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_BODY:
      'Bei Events gilt: Je eher Du sie veröffentlichst, desto mehr Leute werden darauf aufmerksam und können sich den Termin freihalten.',
    'EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.one':
      'Erinnerung: Du hast einen unveröffentlichten Event-Entwurf.',
    'EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.other':
      'Erinnerung: Du hast unveröffentlichte Event-Entwürfe.',
    'EP_EDIT_EVENT_SUBPAGE_DRAFT_MESSAGE_HEADLINE.zero':
      'Zeit, Deiner Gruppe vom nächsten Event zu erzählen! ',
    EP_EDIT_EVENT_SUBPAGE_DRAFT_TAB: 'Entwürfe',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_4_HELP_BODY:
      'Hier findest Du <a>Tipps für Dein Gruppen-Event</a>.',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_4_TITLE_HELP: 'Noch Fragen?',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BODY:
      'Bei einem Event kommt Deine Gruppe zusammen, die Mitglieder lernen sich kennen und tauschen sich aus. Dadurch entsteht erst ein Gemeinschaftsgefühl und Du erweckst die Gruppe zum Leben. ',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_1_BODY:
      'Zuallererst solltest Du festlegen: Wann findet das Event statt? Trefft Ihr Euch online oder vor Ort? Und worum soll es gehen? Mit diesen Infos kannst Du Dein Event erstellen.',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_1_TITLE: '1. Die Eckdaten',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_2_BODY:
      'Kümmer Dich als nächstes um die Details: Wie ist der Ablauf, gibt es Vorträge oder eine Networking-Runde und wie sehen die Online-Anmeldung oder der Einlass aus?',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_2_TITLE: '2. Der Feinschliff',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_3_BODY:
      'Sobald die Eventseite steht, lad Deine Gruppe und Leute aus Deinem Netzwerk oder Deiner Branche ein. Dadurch werden auch andere XING Mitglieder auf Dein Event aufmerksam. ',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_3_TITLE: '3. Die Gäste',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_BULLET_HEADLINE: 'So gehst Du vor:',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_CTA: 'Gruppen-Event organisieren',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_FAQ_LINK:
      'Hier findest Du Tipps für Dein Gruppen-Event.',
    EP_EDIT_EVENT_SUBPAGE_EMPTY_STATE_HEADLINE: 'Plan Dein nächstes Event.',
    EP_EDIT_EVENT_SUBPAGE_LIVE_TAB: 'Veröffentlicht',
    EP_EDIT_EVENT_SUBPAGE_MORE_BUTTON: 'Mehr anzeigen',
    EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_BODY:
      'Regelmäßige Treffen fördern den Austausch untereinander und locken auch immer wieder neue Leute in Deine Gruppe.',
    EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_HEADLINE:
      'Zeit fürs nächste Gruppen-Event?',
    EP_EDIT_EVENT_SUBPAGE_PAST_EMPTY_STATE_TIP:
      'Tipp: Spar Zeit, indem Du Dein letztes Gruppen-Event kopierst.',
    EP_EDIT_EVENT_SUBPAGE_PAST_TAB: 'Archiv',
    'EP_EDIT_EVENT_UPCOMING_TITLE.one': 'Anstehendes Event',
    'EP_EDIT_EVENT_UPCOMING_TITLE.other': 'Anstehende Events',
    'EP_EDIT_EVENT_UPCOMING_TITLE.zero': 'Anstehende Events',
    EP_EDIT_FOUNDINGYEAR: 'Gründungsjahr',
    EP_EDIT_FOUNDINGYEAR_FIELD_LABEL: 'Gründungsjahr',
    EP_EDIT_GALLERY: 'Galerie bearbeiten',
    EP_EDIT_GALLERY_EMPTY_STATE_BODY:
      'Mit Bildern und Videos wird Eure Seite lebendiger und eindrucksvoller. Hier ist Platz dafür.',
    EP_EDIT_GALLERY_EMPTY_STATE_CTA_IMAGE: 'Bild hinzufügen',
    EP_EDIT_GALLERY_EMPTY_STATE_CTA_VIDEO: 'Video hinzufügen ',
    EP_EDIT_GALLERY_EMPTY_STATE_HEADER: 'Sehenswert: Eure XING Seite.',
    EP_EDIT_GROUP_RULES: 'Gruppenregeln bearbeiten',
    EP_EDIT_IMPRINT: 'Impressum',
    EP_EDIT_IMPRINT_FIELD_LABEL: 'Impressum',
    EP_EDIT_INDUSTRY: 'Branche',
    EP_EDIT_INDUSTRY_FIELD_LABEL: 'Branche',
    EP_EDIT_INDUSTRYSEGMENT: 'Bereich',
    EP_EDIT_INDUSTRYSEGMENT_FIELD_LABEL: 'Bereich',
    EP_EDIT_INFO_EDIT_VIEW: 'Bearbeitungs-Ansicht',
    EP_EDIT_INFO_MOBILE:
      'Bitte nutzen Sie zur Bearbeitung einen <span>großen Bildschirm</span>.',
    EP_EDIT_INFO_MOBILE_EDITABLE:
      'Leider lassen sich noch nicht alle Bereiche am kleinen Bildschirm bearbeiten. Wir arbeiten aber dran.',
    EP_EDIT_INFO_VISITOR_VIEW: 'Besucheransicht',
    EP_EDIT_LOCATION_ADDRESS: 'Straße und Hausnr.',
    EP_EDIT_LOCATION_ADDRESSSUFFIX: 'Adresszusatz',
    EP_EDIT_LOCATION_CITY: 'Ort',
    EP_EDIT_LOCATION_COUNTRY: 'Land',
    EP_EDIT_LOCATION_EMAIL: 'E-Mail',
    EP_EDIT_LOCATION_FAXNUMBER: 'Fax',
    EP_EDIT_LOCATION_FAXNUMBERCOUNTRYCODE: 'Landesvorwahl',
    EP_EDIT_LOCATION_LABEL: 'Standort',
    EP_EDIT_LOCATION_PHONENUMBER: 'Telefon',
    EP_EDIT_LOCATION_PHONENUMBERCOUNTRYCODE: 'Landesvorwahl',
    EP_EDIT_LOCATION_POSTCODE: 'PLZ',
    EP_EDIT_LOCATION_WEBSITEURL: 'Website',
    EP_EDIT_PAGEINFO_COMPANY_BANNER:
      'Möchten Sie den Namen der Seite ändern? Kontaktieren Sie uns dafür bitte.',
    EP_EDIT_SECTION: 'Ausschnitt ändern',
    EP_EDIT_SELECTION: 'Einträge bearbeiten',
    EP_EDIT_SUBPAGE_LINK: 'Detailseite bearbeiten',
    EP_EDIT_WEBSITEURL: 'Website',
    EP_EDIT_WEBSITEURL_FIELD_LABEL: 'Website',
    EP_EDITBAR_MANAGE_UPDATES: 'Neuigkeiten verwalten',
    EP_EDITOR_BODY_PLACEHOLDER:
      'Füge eine Beschreibung über Euer Unternehmen hinzu.',
    EP_EDITOR_TITLE_PLACEHOLDER: 'Gib einen Titel an, z. B. „Wer wir sind“.\t',
    EP_EMPLOYEE: 'Mitarbeitende·r',
    EP_EMPLOYEE_CARD_SHARED_CONTACTS:
      '{sharedContactsNumber} gemeinsame Kontakte',
    'EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.one': '{value} gemeinsamer Kontakt',
    'EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.other': '{value} gemeinsame Kontakte',
    'EP_EMPLOYEE_CARD_SHARED_CONTACTS_WEB.zero': 'Keine gemeinsamen Kontakte',
    EP_EMPLOYEE_FENCED:
      'Logg Dich ein, um alle {total} Mitarbeitenden auf XING zu sehen – und Deine persönliche Verbindung zum Unternehmen.',
    EP_EMPLOYEES: 'Mitarbeitende',
    EP_EMPLOYEES_BUTTON_ADD_CONTACT: 'Hinzufügen',
    EP_EMPLOYEES_BUTTON_REGISTER_NOW: 'Registrieren',
    EP_EMPLOYEES_BUTTON_SEND_MESSAGE: 'Nachricht',
    EP_EMPLOYEES_BUTTON_SIGN_IN: 'Einloggen',
    EP_EMPLOYEES_COUNT: '{employeesNumber} Mitarbeitende',
    EP_EMPLOYEES_DESCRIPTION: 'Mitarbeitende',
    EP_EMPLOYEES_EDIT_HINT:
      'Hier werden alle XING Mitglieder gelistet, die Ihr Unternehmen als Arbeitgeber angegeben haben.',
    EP_EMPLOYEES_EMPTY_STATE:
      'Bisher hat noch kein Mitglied dieses Unternehmen als Arbeitgeber angegeben.',
    EP_EMPLOYEES_FEEDBACK_ERROR: 'Das hat leider nicht geklappt.',
    EP_EMPLOYEES_HEADLINE: 'Mitarbeitende',
    EP_EMPLOYEES_LINK: 'Alle {number} Mitarbeitenden',
    EP_EMPLOYEES_LOAD_MORE_CTA: 'Weitere Mitarbeitende',
    EP_EMPLOYEES_NAVIGATION_TITLE: 'Mitarbeitende',
    EP_EMPLOYEES_NUMBER_EMPTY_STATE: 'Unternehmensgröße',
    EP_EMPLOYEES_OR: 'oder',
    EP_EMPLOYEES_SIGNIN: 'Einloggen',
    EP_EMPLOYEES_SUBPAGE_DESCRIPTION:
      'Auf einen Blick: Alle Mitarbeitenden von {pageTitle}, die bei XING sind.',
    EP_EMPLOYEES_TEXT_CTA_REGISTER_TO_SEE:
      'Registrier Dich, um alle {employeesNumber} Mitarbeitenden zu sehen.',
    EP_EMPLOYEES_TEXT_PROFILE_IMAGE_ALT: 'Profilbild von {profileName}',
    EP_EMPLOYEES_VIEW_PROFILE: 'Profil ansehen',
    EP_ERROR: 'Warum ist hier denn nichts zu sehen?',
    EP_ERROR_BODY:
      'Vielleicht klappt\'s wieder, wenn Du auf "Aktualisieren" klickst.',
    EP_ERROR_HEADER: 'Warum ist hier denn nichts zu sehen?',
    EP_ERROR_RELOAD_CTA: 'Aktualisieren',
    EP_EVENT_ALL_CTA: 'Alle Events',
    EP_EVENT_ALL_LINK: 'Alle Events',
    EP_EVENT_DELETE_ERROR:
      "Das hat gerade leider nicht geklappt. Versuchen Sie's bitte noch einmal.",
    EP_EVENT_EMPTY_STATE_BODY:
      'Sobald das nächste Event feststeht, werden die Mitglieder der Gruppe darüber benachrichtigt.',
    EP_EVENT_EMPTY_STATE_HEADLINE:
      'In dieser Gruppe haben noch keine Events stattgefunden.',
    EP_EVENT_PAST_TITLE: 'Vergangenes Event',
    EP_EVENT_SUBPAGE_BACK_LINK: 'Zurück zur Übersicht',
    EP_EVENT_SUBPAGE_EMPTY_STATE_PAST:
      'In dieser Gruppe haben noch keine Events stattgefunden.',
    EP_EVENT_SUBPAGE_EMPTY_STATE_PAST_BODY:
      'Sobald das nächste Event feststeht, werden die Mitglieder der Gruppe darüber benachrichtigt.',
    EP_EVENT_SUBPAGE_EMPTY_STATE_UPCOMING:
      'Zurzeit stehen keine Gruppen-Events an.',
    EP_EVENT_SUBPAGE_EMPTY_STATE_UPCOMING_BODY:
      'Sobald das nächste Event feststeht, werden die Mitglieder der Gruppe darüber benachrichtigt.',
    EP_EVENT_SUBPAGE_MORE_CTA: 'Mehr anzeigen',
    EP_EVENT_SUBPAGE_PAST_TAB: 'Vergangene Events',
    EP_EVENT_SUBPAGE_UPCOMING_TAB: 'Anstehende Events',
    'EP_EVENT_UPCOMING_TITLE.one': 'Anstehendes Event',
    'EP_EVENT_UPCOMING_TITLE.other': 'Anstehende Events',
    'EP_EVENT_UPCOMING_TITLE.zero': 'Anstehende Events',
    EP_EVENTS_DESCRIPTION: 'Events',
    EP_EVENTS_HEADLINE: 'Events',
    EP_EVENTS_NAVIGATION_TITLE: 'Events',
    EP_EXISTING_COMPANY_NAME:
      'Es gibt schon eine XING Seite mit diesem Namen – nehmen Sie bitte einen anderen.',
    EP_FAX: 'Fax',
    EP_FEEDBACK_BUTTON: 'Feedback?',
    EP_FIELD_EMPTY_OR_MIN_CHARACTERS_ERROR:
      'Geben Sie hier bitte nichts oder mind. {value} Zeichen ein.',
    EP_FIELD_MAX_CHARACTERS_ERROR: 'Hier bitte max. {value} Zeichen eingeben',
    EP_FIELD_REQUIRED_ERROR: 'Können Sie dieses Feld bitte noch ausfüllen?',
    EP_FILE_SIZE_FORMAT_ERROR:
      'Bitte wählen Sie ein PDF-Dokument, das max. 100 MB groß ist.',
    EP_FIND_US_HERE: 'Hier findest Du uns:',
    EP_FLAG_EMPLOYER_BRANDING_PROFILE: 'Employer Branding Profile',
    EP_FOLLOW: 'Folgen',
    'EP_FOLLOWERS_COUNT_WEB.one': '{value} Follower',
    'EP_FOLLOWERS_COUNT_WEB.other': '{value} Follower',
    'EP_FOLLOWERS_COUNT_WEB.zero': 'Keine Follower',
    'EP_FOLLOWERS_SOCIAL_PROOF.one': '{username} folgt dieser Seite.',
    'EP_FOLLOWERS_SOCIAL_PROOF.other':
      '{numberOfContacts} Deiner Kontakte folgen dieser Seite.',
    'EP_FOLLOWERS.one': 'Follower',
    'EP_FOLLOWERS.other': 'Follower',
    'EP_FOLLOWERS.zero': 'Follower',
    EP_FOLLOWING: 'Folgst Du',
    EP_FORMATTEDTIMESTAMP_DAYSAGO: 'Vor {number} Tagen',
    EP_FORMATTEDTIMESTAMP_DAYSAGO_SHORT: '{number} Tage',
    EP_FORMATTEDTIMESTAMP_TODAY: 'Heute',
    EP_FORMATTEDTIMESTAMP_YESTERDAY: 'Gestern',
    EP_FOUNDING_YEAR: '{foundingYear} gegründet',
    EP_FOUNDING_YEAR_EMPTY_STATE: 'Gründungsjahr',
    EP_FREE_ADD_CONTACT_INFO:
      'Mit der kostenlosen XING Seite können Sie nur eine Ansprechperson angeben. Daher haben wir Ihre bisherige Ansprechperson ersetzt.',
    EP_FREE_CONTACTS_PROBLEM:
      "Leider ist die Ansprechperson gerade nicht änderbar. Bitte versuchen Sie's später nochmal.",
    EP_GALLERY_MANAGER_INFO:
      'Hier können Sie Ihre Bilder und Videos verschieben, bearbeiten und löschen. Übrigens: Die obersten vier Bilder / Videos erscheinen im Modul "Impressionen" auf der Übersicht Ihrer XING Seite.',
    EP_GENERAL_ERROR_BUTTON: 'Neu laden',
    EP_GENERAL_ERROR_TEXT: 'Bitte lade die Seite erneut.',
    EP_GENERAL_ERROR_TITLE: 'Sieht so aus, als hätten wir ein Problem.',
    EP_GENERAL_FEEDBACK_ERROR:
      "Das hat leider nicht geklappt – versuchen Sie's einfach nochmal.",
    EP_GENERIC_FEEDBACK_ERROR:
      'Hoppla! Sieht so aus, als würde unser Server gerade nicht ganz rund laufen. Versuchen Sie es bitte nochmal.',
    EP_GM_IMAGE_CAPTION_HINT: 'Was soll unter dem Bild stehen?',
    EP_GM_IMAGE_CAPTION_LABEL: 'Bildunterschrift',
    EP_GM_IMAGE_INFO_BANNER: 'So wählst Du ideale Bilder aus:',
    EP_GM_IMAGE_INFO_BANNER_CTA: 'Tipps lesen',
    EP_GM_IMAGE_WILL_BE_DELETED: 'Bild gelöscht',
    EP_GM_NO_MEDIA:
      'Starten Sie eine Galerie: mit Bildern und Videos aus Ihrem Unternehmen.',
    EP_GM_NO_MEDIA_HEADLINE: 'Zeigen Sie hier Eindrücke aus Ihrem Unternehmen.',
    EP_GM_VIDEO_ENCODING:
      'Das Video <span>“{video_name}“</span> wird aufbereitet.',
    EP_GM_VIDEO_ENCODING_FAILED_INFO:
      'Dieses Video kann leider nicht abgespielt werden und wird deshalb entfernt. So sollte das Video sein: Eine Datei im Format .avi .mov oder .mp4, im Verhältnis 16: 9 und max. 5 GB groß.',
    EP_GM_VIDEO_ENCODING_FAILED_TITLE:
      'Videokodierung für <span>“{video_name}“</span> fehlgeschlagen',
    EP_GM_VIDEO_ENCODING_MESSAGE:
      'Wir werden Sie per E-Mail informieren, sobald es fertig und veröffentlicht ist.',
    EP_GM_VIDEO_WILL_BE_DELETED: 'Video gelöscht',
    EP_GO_HOME: 'Zur Startseite',
    EP_GROUP_ABOUT_LEGAL_NOTICE: 'Impressum',
    EP_GROUP_ABOUT_US_BOX_CATEGORIES_TITLE: 'Thema',
    EP_GROUP_ABOUT_US_BOX_HEADLINE: 'Infos',
    EP_GROUP_ABOUT_US_CATEGORY: 'Thema',
    'EP_GROUP_ABOUT_US_EVENTS.one': '{amount} Event',
    'EP_GROUP_ABOUT_US_EVENTS.other': '{amount} Events',
    'EP_GROUP_ABOUT_US_EVENTS.zero': 'Keine Events',
    EP_GROUP_ABOUT_US_FACTS: 'Infos',
    'EP_GROUP_ABOUT_US_MEMBERS.one': '{amount} Mitglied',
    'EP_GROUP_ABOUT_US_MEMBERS.other': '{amount} Mitglieder',
    'EP_GROUP_ABOUT_US_MEMBERS.zero': 'Keine Mitglieder',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_BODY:
      'Leg hier fest, wie Mitglieder sich verhalten sollen. ',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_CTA: 'Hinzufügen',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_EDIT: 'Bearbeiten',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_HEADER: 'Was geht – und was nicht?',
    EP_GROUP_ABOUT_US_RULES_EMPTY_STATE_HELP_TEXT:
      'Erklär, wie sich Gruppen-Mitglieder verhalten sollen, z. B. ...\n<ul>\n <li>welche Beiträge relevant sind und wie die Gruppe zu Spam steht und</li>\n <li>dass der Umgangston bei einer Diskussion wertschätzend bleiben sollte.</li>\n</ul>\n Die Regeln sollten übrigens gut leserlich sein, z. B. durch Stichpunkte.',
    EP_GROUP_ABOUT_US_RULES_PLACEHOLDER:
      'Leg hier fest, was erlaubt ist – und was nicht.',
    EP_GROUP_ABOUT_US_TITLE: 'Dürfen wir uns vorstellen?',
    EP_GROUP_ABOUT_US_UPCOMING_EVENTS_NONE: 'Keine anstehenden Events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.one': '{amount} anstehendes Event',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.other': '{amount} anstehende Events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS_WEB.zero': 'Keine anstehenden Events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS.one': '%,d anstehendes Event',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS.other': '%,d anstehende Events',
    'EP_GROUP_ABOUT_US_UPCOMING_EVENTS.zero': 'Keine anstehenden Events',
    EP_GROUP_ABOUT_US_VISIBILITY_PRIVATE: 'Privat',
    EP_GROUP_ABOUT_US_VISIBILITY_PUBLIC: 'Öffentlich',
    EP_GROUP_CREATION_CANCEL_CTA: 'Gruppe verwerfen',
    EP_GROUP_CREATION_CANCEL_KEEP_CTA: 'Nein, behalten',
    EP_GROUP_CREATION_CANCEL_TEXT:
      'Deine Eingaben auf dieser Seite gehen dann verloren.',
    EP_GROUP_CREATION_CANCEL_TITLE:
      'Möchtest Du Deine Gruppe wirklich verwerfen?',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_1: 'Name & Einstellungen',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_2: 'Thema',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_3: 'Beschreibung',
    EP_GROUP_CREATION_PROGRESS_BAR_TITLE_4: 'Logo',
    EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_1:
      'förderst Du den Netzwerk-Gedanken und machst die Mitglieder miteinander bekannt.',
    EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_2:
      'unterstützt Du die Mitglieder dabei, persönliche Kontakte zu knüpfen.\n',
    'EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_2\n':
      'unterstützt Du die Mitglieder dabei, persönliche Kontakte zu knüpfen.\n',
    EP_GROUP_CREATION_STEP_1_CONDUCT_BULLET_3:
      'organisierst Du regelmäßig Events (z. B. Workshops, Meetups oder Feierabend-Treffs).',
    EP_GROUP_CREATION_STEP_1_CONDUCT_LEGAL: 'Ja, ich akzeptiere den {link}.',
    EP_GROUP_CREATION_STEP_1_CONDUCT_LEGAL_LINK:
      'Verhaltenskodex für die Moderation',
    EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_FEMALE:
      'Als Moderatorin einer Gruppe ...',
    EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_MALE:
      'Als Moderator einer Gruppe ...',
    EP_GROUP_CREATION_STEP_1_CONDUCT_TITLE_OTHER:
      'Als Moderatx einer Gruppe ...',
    EP_GROUP_CREATION_STEP_1_LOCATION_HELP_TEXT:
      'Wenn Du eine Stadt auswählst, empfehlen wir Deine Gruppe Mitgliedern, die von dort kommen oder dort arbeiten, auf deren Gruppen-Startseite. Es können aber auch andere Deiner Gruppe beitreten.',
    EP_GROUP_CREATION_STEP_1_LOCATION_OPTIONAL: '(Optional)',
    EP_GROUP_CREATION_STEP_1_LOCATION_TITLE:
      'Wähl hier Deine Stadt für eine lokale Gruppe aus. Sie wird dadurch Leuten aus der Gegend angezeigt.',
    EP_GROUP_CREATION_STEP_1_NAME_HEADER: 'Wie soll Deine Gruppe heißen?',
    EP_GROUP_CREATION_STEP_1_NAME_HELP_TEXT:
      "Der Gruppenname ist das Erste, was Deine neuen Mitglieder sehen. Wähl deshalb einen Namen, der auf den Punkt bringt, worum's geht.",
    EP_GROUP_CREATION_STEP_1_NAME_PLACEHOLDER: 'Z. B. "Marketing {city}"',
    EP_GROUP_CREATION_STEP_1_TITLE: 'Name & Einstellungen',
    EP_GROUP_CREATION_STEP_1_VISIBILITY_HELP_TEXT:
      'Bei öffentlichen Gruppen können alle XING Mitglieder sehen, wer in der Gruppe ist, und Beiträge lesen. <br>\nWenn die Gruppe privat ist, können das nur Gruppen-Mitglieder. <br>\nDie Privatsphäre-Einstellungen für Events gelten unabhängig von denen der Gruppe: Öffentliche Gruppen können auch private Events veranstalten und umgekehrt.',
    EP_GROUP_CREATION_STEP_1_VISIBILITY_PRIVATE:
      'Privat (nicht nachträglich änderbar)',
    EP_GROUP_CREATION_STEP_1_VISIBILITY_PUBLIC: 'Öffentlich',
    EP_GROUP_CREATION_STEP_1_VISIBILITY_TITLE:
      'Ist Deine Gruppe privat oder öffentlich?',
    EP_GROUP_CREATION_STEP_2_CATEGORY_HEADER:
      'Wähle Themen aus, die zu Deiner Gruppe passen.',
    EP_GROUP_CREATION_STEP_2_CATEGORY_HELPTEXT:
      'Füge hier bis zu 20 Themen hinzu. Dadurch können Interessenten Deine Gruppe bei der Suche nach diesen Themen finden und beitreten oder an Deinen Events teilnehmen.',
    EP_GROUP_CREATION_STEP_2_CATEGORY_PLACEHODER:
      'Z. B. "Marketing" oder "Projektmanagement"\n',
    EP_GROUP_CREATION_STEP_3_DESCRIPTION_HEADER:
      "Worum geht's in Deiner Gruppe?",
    EP_GROUP_CREATION_STEP_3_DESCRIPTION_HELP:
      'Beantworte z. B. diese Fragen:\n <ul>\n  <li>Für wen könnte die Gruppe interessant sein?</li>\n  <li>Was macht sie aus?</li>\n  <li>Wie oft finden Gruppen-Events statt und wie laufen die ab?</li>\n</ul> \n\nDu kannst übrigens {min}-{max} Zeichen verwenden und den Text auch formatieren.',
    EP_GROUP_CREATION_STEP_3_DESCRIPTION_PLACEHOLDER:
      'Z. B. "Bei uns lernt Ihr andere aus der Branche kennen und tauscht Euch über Erfolge, Fehlschläge, Tipps und Neuigkeiten aus."\n',
    EP_GROUP_CREATION_STEP_4_CTA_CREATE_GROUP: 'Gruppe beantragen',
    EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_CTA: 'Datei auswählen',
    EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_HINT:
      'JPG, BMP oder PNG (max. 20 MB) im Format 16:9',
    EP_GROUP_CREATION_STEP_4_UPLOAD_LOGO_TITLE:
      'Logo hierher ziehen oder auswählen',
    EP_GROUP_CREATION_SUCCESS_BULLET_1:
      'Wir schauen sie uns gleich an. Du bekommst dann eine E-Mail, sobald Deine Gruppe freigegeben wird. Das kann bis zu 48 Stunden dauern.',
    EP_GROUP_CREATION_SUCCESS_BULLET_2:
      'In der Zwischenzeit kannst Du ein Banner, Bilder oder ein Video hochladen. (Nutz dazu bitte einen Desktop-PC.)',
    EP_GROUP_CREATION_SUCCESS_BULLET_3:
      'Oder Du schreibst einen Willkommens-Beitrag. Neue Mitglieder sehen diesen, sobald die Gruppe freigegeben wurde.',
    EP_GROUP_CREATION_SUCCESS_CTA_BACK: 'Zur Gruppen-Übersicht',
    EP_GROUP_CREATION_SUCCESS_HEADLINE: 'Deine neue Gruppe "<name>" ist da.',
    EP_GROUP_CREATION_SUCCESS_LARGE_SCREEN_CTA: 'Zur Gruppe',
    EP_GROUP_CREATION_SUCCESS_SMALL_SCREEN_CTA: 'Zur Gruppe',
    EP_GROUP_DELETION_CTA: 'Jetzt löschen',
    EP_GROUP_DELETION_ERROR:
      "Deine Gruppe konnte gerade leider nicht gelöscht werden. Versuch's bitte nochmal.",
    EP_GROUP_DELETION_KEEP_CTA: 'Gruppe behalten',
    EP_GROUP_DELETION_SUCCESS: 'Deine Gruppe wurde gelöscht.',
    EP_GROUP_DELETION_TITLE: 'Möchtest Du Deine Gruppe wirklich löschen?',
    EP_GROUP_DISCUSSIONS_LOAD_COMMBOX_ERROR:
      'Wir können gerade keine Beiträge erstellen. Bitte lad diese Seite neu.',
    EP_GROUP_DISCUSSIONS_LOAD_COMMBOX_ERROR_CTA: 'Seite neu laden',
    EP_GROUP_DISCUSSIONS_LOAD_MORE_ERROR:
      "Wir können gerade keine weiteren Beiträge anzeigen. Bitte versuch's gleich nochmal.",
    'EP_GROUP_HEADER_MEMBERS.one': 'Mitglied',
    'EP_GROUP_HEADER_MEMBERS.other': 'Mitglieder',
    'EP_GROUP_HEADER_MEMBERS.zero': 'Mitglieder',
    EP_GROUP_HEADER_VISIBILITY_PRIVATE: 'Privat',
    EP_GROUP_HEADER_VISIBILITY_PUBLIC: 'Öffentlich',
    EP_GROUP_INFO_BLOCKED: 'Blockiert',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP:
      'Bitte übertrag die Moderation jemand anderem, bevor Du sie verlässt.\nKontaktier dafür unseren Kundenservice.',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_CLOSE_CTA: 'Jetzt nicht',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_CONTACT_CTA: 'Kontaktieren',
    EP_GROUP_LEAVE_OWNER_ERROR_POP_UP_TITLE: 'Diese Gruppe gehört Dir.',
    EP_GROUP_LEAVE_TRANSFER_OWNERSHIP_EMAIL_ADDRESS: 'de-support@xing.com',
    EP_GROUP_LEAVE_TRANSFER_OWNERSHIP_SUBJECT:
      'Ich möchte die Gruppen-Verantwortlichkeit abgeben.',
    EP_GROUP_LOCATION_TITLE: 'Ort',
    EP_GROUP_MEMBER_ADD_CONTACT: 'Vernetzen',
    EP_GROUP_MEMBER_ADD_CONTACT_ERROR:
      "Das hat leider nicht geklappt. Bitte versuch's nochmal.",
    EP_GROUP_MEMBER_ALL_LINK: 'Alle Gruppen-Mitglieder',
    'EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.one': '%d gemeinsamer Kontakt',
    'EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.other': '%d gemeinsame Kontakte',
    'EP_GROUP_MEMBER_CONTACT_SHARED_CONTACTS.zero': '%d shared contacts',
    EP_GROUP_MEMBER_EDIT: 'Mitglieder verwalten',
    EP_GROUP_MEMBER_INVITE_CTA: 'Mitglieder einladen',
    EP_GROUP_MEMBER_INVITE_PLACEHOLDER:
      'Hallo,\nich möchte Dich gerne in die Gruppe "{group_name}" einladen und freue mich, Dich bald dort zu sehen!\n\nViele Grüße\n{invitor_name}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_EMPTY_BODY:
      'Alle Mitglieder haben Zugriff auf diese Gruppe und können Beiträge schreiben, lesen und kommentieren.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_EMPTY_TITLE:
      'Niemand ist zur Zeit blockiert.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_SINCE: 'Blockiert seit {date}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_BLOCKED_SWITCHER: 'Blockiert',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_EMPTY_BODY:
      'Ausgeschlossene Personen verlieren ihre Mitgliedsrechte und können erst wieder beitreten, wenn Du den Ausschluss aufhebst.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_EMPTY_TITLE:
      'Niemand ist zur Zeit ausgeschlossen.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_SINCE:
      'Ausgeschlossen seit {date}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_EXCLUDED_SWITCHER: 'Ausgeschlossen',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_MEMBERS_SWITCHER: 'Mitglieder',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_EMPTY_BODY:
      'Sobald jemand dieser Gruppe beitreten möchte, sieht Du die Mitgliedsanfrage hier.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_EMPTY_TITLE:
      'Zur Zeit gibt es keine neuen Mitgliedsanfragen.',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_SINCE:
      'Mitgliedsanfrage vom {date}',
    EP_GROUP_MEMBER_MODERATOR_SUBPAGE_REQUESTED_SWITCHER: 'Anfragen',
    EP_GROUP_MEMBER_POP_UP_BODY_LO:
      'Registrier Dich kostenlos oder logg Dich ein, um alle {count} Mitglieder zu sehen.',
    EP_GROUP_MEMBER_REGISTER_LO: 'Kostenlos registrieren',
    EP_GROUP_MEMBER_SEARCH_EMPTY_BODY:
      "Wird die Person vielleicht anders geschrieben? Versuch's einfach nochmal oder mit einem anderen Wort.",
    EP_GROUP_MEMBER_SEARCH_EMPTY_HEADLINE:
      'Mit diesem Namen haben wir leider niemanden gefunden.',
    EP_GROUP_MEMBER_SIGN_IN_LO: 'Einloggen',
    EP_GROUP_MEMBER_SUBPAGE_MORE_CTA: 'Mehr anzeigen',
    EP_GROUP_MEMBER_TITLE: 'Mitglieder',
    EP_GROUP_MEMBER_VIEW_PROFILE_LO: 'Profil ansehen',
    EP_GROUP_MEMBER_WRITE_MESSAGE: 'Nachricht schreiben',
    EP_GROUP_MEMBERS_ADD_AS_MODERATOR: 'Ins Moderations-Team holen',
    EP_GROUP_MEMBERS_ADD_AS_MODERATOR_SUCCESS:
      'Du hast {name} ins Moderations-Team Deiner Gruppe geholt.',
    EP_GROUP_MEMBERS_BLOCK_MEMBER: 'Mitglied blockieren',
    EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP:
      '{first_name} kann dann solange keine Beiträge oder Kommentare veröffentlichen, bis Du die Blockierung aufhebst.',
    EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP_HEADLINE: '{name} blockieren?',
    EP_GROUP_MEMBERS_BLOCK_MEMBER_POP_UP_YES: 'Ja, blockieren',
    EP_GROUP_MEMBERS_BLOCK_MEMBER_SUCCESS: '{name} ist jetzt blockiert.',
    EP_GROUP_MEMBERS_BLOCK_MEMBERSHIP_POP_UP_CTA_CANCEL: 'Abbrechen',
    EP_GROUP_MEMBERS_CHANGE_ROLE_ERROR:
      'Das hat leider nicht geklappt. Kannst Du es bitte noch einmal versuchen?',
    EP_GROUP_MEMBERS_CHANGE_STATUS_POP_UP_CANCEL: 'Abbrechen',
    EP_GROUP_MEMBERS_CONFIRM_MEMBER_SUCCESS:
      '{first_name} ist jetzt auch ein Mitglied dieser Gruppe.',
    EP_GROUP_MEMBERS_DECLINE_MEMBER_SUCCESS:
      'Du hast die Mitgliedsanfrage von {name} abgelehnt.',
    EP_GROUP_MEMBERS_GROUP_OWNER_INFO: 'Hat die Gruppe am {date} gegründet',
    EP_GROUP_MEMBERS_GROUP_PENDING_OWNER_INFO:
      'Sobald Deine Gruppe freigegeben wird, kannst Du Leute dazu einladen.',
    EP_GROUP_MEMBERS_LOAD_MORE_ERROR:
      "Wir können gerade keine weiteren Mitglieder anzeigen. Bitte versuch's gleich nochmal.",
    EP_GROUP_MEMBERS_MEMBERSHIP_ACTION_ERROR:
      "Das hat leider nicht geklappt. Bitte versuch's nochmal.",
    EP_GROUP_MEMBERS_MEMBERSHIP_INFO: 'Mitglied seit dem {date}',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.one':
      'Soll Deine Gruppe wachsen? Nimm die Anfrage an und heiß Dein neues Mitglied willkommen, oder lehn sie ab.',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.other':
      'Soll Deine Gruppe wachsen? Nimm die Anfragen an und heiß Deine neuen Mitglieder willkommen, oder lehn sie ab.',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_BODY.zero':
      'Do you want your group to grow? Accept the request to welcome your new member or decline it.',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.one': 'Mitgliedsanfrage ansehen',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.other': 'Mitgliedsanfragen ansehen',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS_CTA.zero': 'View pending requests',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS.one': '{number} offene Mitgliedsanfrage',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS.other': '{number} offene Mitgliedsanfragen',
    'EP_GROUP_MEMBERS_OPEN_REQUESTS.zero':
      '{number} pending membership requests',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP: 'Ausschluss aufheben',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_BODY: 'Ausschluss aufheben? ',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_CTA_CANCEL: 'Abbrechen',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_CTA_YES: 'Ausschluss aufheben',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_SUCCESS:
      '{name} kann jetzt eine neue Mitgliedsanfrage stellen.',
    EP_GROUP_MEMBERS_REINSTATE_MEMBERSHIP_TEXT:
      '{name} ist dann nicht mehr ausgeschlossen, aber auch noch nicht wieder Mitglied dieser Gruppe. Dafür braucht es eine erneute Mitgliedsanfrage.',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR: 'Moderationsstatus aufheben',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP:
      '{name} aus dem Moderations-Team entfernen?',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP_CONTENT:
      'Dadurch verliert {first_name} den Moderations-Status und ist wieder normales Mitglied.',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_POP_UP_YES: 'Ja, entfernen',
    EP_GROUP_MEMBERS_REMOVE_AS_MODERATOR_SUCCESS:
      'Du hast {name} aus dem Moderations-Team entfernt.',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP: 'Aus der Gruppe ausschließen',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_HEADLINE:
      '{name} aus der Gruppe ausschließen?',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP:
      '{first_name} ist dann kein Mitglied mehr und kann der Gruppe so lange nicht wieder beitreten, bis Du den Ausschluss aufhebst.',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP_CANCEL: 'Abbrechen',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_POP_UP_YES: 'Ausschließen',
    EP_GROUP_MEMBERS_REMOVE_MEMBER_FROM_GROUP_SUCCESS:
      '{name} ist jetzt aus der Gruppe ausgeschlossen.',
    EP_GROUP_MEMBERS_SEARCH_BAR: 'Z. B. "Max Mustermann"',
    EP_GROUP_MEMBERS_SEARCH_BAR_MOBILE: 'Z. B. "Max Mustermann"',
    EP_GROUP_MEMBERS_SEARCH_BUTTON: 'Mitglieder durchsuchen',
    'EP_GROUP_MEMBERS_TOTAL.one': 'Eine Person',
    'EP_GROUP_MEMBERS_TOTAL.other': '{value} Personen',
    'EP_GROUP_MEMBERS_TOTAL.zero': 'Niemand',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBER: 'Blockierung aufheben',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBER_POP_UP:
      '{first_name} kann dann wieder Beiträge und Kommentare in dieser Gruppe schreiben.',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBER_SUCCESS:
      'Die Blockierung ist jetzt aufgehoben. {name} kann wieder was veröffentlichen.',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_CTA_CANCEL: 'Abbrechen',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_CTA_YES: 'Blockierung aufheben',
    EP_GROUP_MEMBERS_UNBLOCK_MEMBERSHIP_POP_UP_HEADLINE:
      '{name} nicht mehr blockieren?',
    EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_BODY:
      "Bestimmt gibt's in Deinem persönlichen Netzwerk spannende Leute, die Deiner Gruppe beitreten und an Deinen Events teilnehmen möchten.",
    EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_CTA: 'Leute einladen',
    EP_GROUP_MEMBERS_UNDER_10_OWNER_BANNER_HEADLINE:
      'Wen suchst Du für Deine Gruppe?',
    EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_BODY:
      'Kennst Du Leute, die zu dieser Gruppe passen? Oder daran interessiert sind, Gruppen-Mitglieder kennenzulernen? Lad sie ein, beizutreten.',
    EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_CTA: 'Kontakte einladen',
    EP_GROUP_MEMBERS_UNDER_10_VISITOR_BANNER_HEADLINE:
      'Wer sollte dieser Gruppe noch beitreten?',
    EP_GROUP_OWNER_DRAFT_BANNER_BODY:
      'Es fehlen nur noch ein paar Infos. Und sobald sie veröffentlicht ist, kannst Du Leute in Deine Gruppe einladen.',
    EP_GROUP_OWNER_DRAFT_BANNER_DELETE_CTA: 'Gruppe verwerfen',
    EP_GROUP_OWNER_DRAFT_BANNER_FINISH_CTA: 'Jetzt fertigstellen',
    EP_GROUP_OWNER_DRAFT_BANNER_TITLE:
      'Deine Gruppe <b>"%group_name</b> ist fast fertig ...',
    EP_GROUP_OWNER_YOUR_GROUPS_PENDING_INFO:
      'Wird gerade geprüft (Antrag vom {date})',
    EP_GROUP_ROLE_INFO_MEMBER: 'Mitglied',
    EP_GROUP_ROLE_INFO_MODERATOR: 'Moderation',
    EP_GROUP_RULES_TITLE: 'Gruppenregeln',
    'EP_GROUP_SOCIAL_PROOF.one': '{username} ist schon dabei.',
    'EP_GROUP_SOCIAL_PROOF.other':
      '{numberOfContacts} Deiner Kontakte sind schon dabei.',
    EP_GROUP_START_PAGE_BODY:
      'Gruppen sind dazu da, echte Menschen kennenzulernen und sich auszutauschen. Z. B. bei Meetups zu einem bestimmten Thema oder After-Work-Abenden zum Netzwerken.',
    EP_GROUP_START_PAGE_CREATE_GROUP_CTA: 'Gruppe starten',
    EP_GROUP_START_PAGE_HEADER: 'Entdecke Gruppen, die zu Dir passen!',
    EP_GROUP_START_PAGE_NEW_GROUPS_HEADER: 'Deine Gruppen mit neuem Design',
    EP_GROUP_START_PAGE_NEW_GROUPS_INFO_BODY:
      'Das haben wir auch gefragt. Aber das Team meinte, dass es noch 4 Wochen dauert, bis alle umgestellt sind. Dann haben wir uns doch entschieden, Dir Deine ersten Gruppen im neuen Design gleich zu zeigen.',
    EP_GROUP_START_PAGE_NEW_GROUPS_INFO_TITLE:
      'Warum sind manche Gruppen im neuen und manche im alten Design?',
    EP_GROUP_START_PAGE_NEW_GROUPS_MEMBER_BODY:
      'Ganz neu und aufgehübscht. Und mit verbesserten Funktionen für Events. Die restlichen Gruppen folgen übrigens bald.',
    EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY:
      "Und das hat zwei Ansichten: Eine für Mitglieder und eine für die Moderation. Dadurch kannst Du Deine Gruppen besser verwalten. Außerdem gibt's verbesserte Funktionen für Deine Events. Und auf dem Smartphone oder Tablet sehen Gruppen jetzt auch besser aus. <a href=“https://faq.xing.com/node/68236”>Was ist neu?</a>",
    EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY_ANDROID:
      'Und das hat zwei Ansichten: Eine für Mitglieder und eine für die Moderation. <a href=“https://faq.xing.com/node/68236”>Was ist sonst noch neu?</a>',
    EP_GROUP_START_PAGE_NEW_GROUPS_MODERATOR_BODY_IOS:
      'Und das hat zwei Ansichten: Eine für Mitglieder und eine für die Moderation. <a href=“https://faq.xing.com/node/68236”>Was ist sonst noch neu?</a>',
    EP_GROUP_START_PAGE_OLD_GROUPS_HEADER:
      'Deine Gruppen mit bestehendem Design',
    EP_GROUP_START_PAGE_OLD_GROUPS_MEMBER_BODY:
      'Diese Gruppen sehen noch so aus wie vorher, werden aber auch bald im neuen Design erstrahlen. ',
    EP_GROUP_START_PAGE_SEARCH_GROUP_CTA: 'Nach Gruppen suchen',
    EP_GROUP_START_PAGE_TAB_EMPTY_STATE_BODY:
      'Finde jetzt Deine Gruppe und lern neue Leute kennen.',
    EP_GROUP_START_PAGE_TAB_EMPTY_STATE_CTA: 'Spannende Gruppen entdecken',
    EP_GROUP_START_PAGE_TAB_EMPTY_STATE_TITLE:
      'Alle Deine Gruppen siehst Du hier.',
    EP_GROUP_XBM_ENTRY_BODY:
      'Möchtest Du wissen, wie sich Deine Mitgliederzahlen entwickeln oder wie oft Deine Gruppe gefunden wird? ',
    EP_GROUP_XBM_ENTRY_CTA: 'Zur Gruppen-Analyse',
    EP_HEADER_IMAGE_BANNER_BODY:
      'Gerade kannst Du das Titelbild als <strong>Entwurf speichern</strong> und es ist <strong>nur für Dich sichtbar</strong>. <br />\nMöchtest Du, dass andere Dein Titelbild auch sehen? Dann hole Dir das <strong>Upgrade</strong> und <strong>veröffentliche Dein Bild</strong> danach.',
    EP_HEADER_IMAGE_BANNER_DRAFT_BUTTON:
      'Titelbild erstmal als Entwurf speichern',
    EP_HEADER_IMAGE_BANNER_HEADER:
      'Upgrade sichern und Titelbild veröffentlichen',
    EP_HEADER_IMAGE_BANNER_PUBLISH_BUTTON: 'Upgrade sichern',
    EP_HEADER_LAST_STEP_CREATE_PAGE:
      'Glückwunsch, Ihr Profil {companyName} ist fast fertig!',
    EP_HELP_CENTER: 'Hilfebereich\n',
    EP_IDEAL_EMPLOYER_ADD: 'Als Wunsch-Arbeitgeber hinzufügen',
    EP_IDEAL_EMPLOYER_ADD_CONFIDENTIALLY:
      'Füg dieses Unternehmen einfach als Wunsch-Arbeitgeber hinzu, um es vertraulich über Dein Interesse zu informieren.',
    EP_IDEAL_EMPLOYER_ADDED: 'Als Wunsch-Arbeitgeber hinzugefügt',
    EP_IDEAL_EMPLOYER_ADMIN_ADAPT: 'Das geht direkt im BrandManager.',
    EP_IDEAL_EMPLOYER_ADMIN_GO_BM: 'BrandManager öffnen',
    EP_IDEAL_EMPLOYER_ADMIN_LAPTOP:
      'Das geht direkt im BrandManager (am besten mit etwas größerem Bildschirm). ',
    EP_IDEAL_EMPLOYER_ADMIN_POSITION: ' "Wunsch-Arbeitgeber"-Modul bearbeiten',
    EP_IDEAL_EMPLOYER_CONFIDENTIAL_INFO:
      'Außer dem Arbeitgeber erfährt niemand davon. Es sei denn, Du hast andere in Deinen Job-Wünschen dazu freigeschaltet.',
    EP_IDEAL_EMPLOYER_EDIT_HINT:
      'Im BrandManager sehen Sie, wie viele Mitglieder Ihr Unternehmen aktuell als Wunsch-Arbeitgeber angeben.',
    EP_IDEAL_EMPLOYER_EDIT_HINT_CTA: 'Zum BrandManager',
    EP_IDEAL_EMPLOYER_EI_CONFIDENTIAL:
      'Außer dem Arbeitgeber erfährt davon niemand – es sei denn, Du hast andere in Deinen Job-Wünschen dafür freigeschaltet.',
    EP_IDEAL_EMPLOYER_EI_HOW: 'Wie funktioniert das?',
    EP_IDEAL_EMPLOYER_EI_NON_COMMITTAL:
      'Wir sagen dem Arbeitgeber Bescheid, dass Du gerne dort arbeiten würdest. ',
    EP_IDEAL_EMPLOYER_EI_POTENTIAL:
      'Dadurch erhöhst Du Deine Chance, von diesem Arbeitgeber kontaktiert zu werden.',
    EP_IDEAL_EMPLOYER_EI_UPTO_30:
      'Du kannst bis zu 30 Wunsch-Arbeitgeber eintragen.',
    EP_IDEAL_EMPLOYER_HEADLINE: 'Wunsch-Arbeitgeber',
    EP_IDEAL_EMPLOYER_MAX:
      'Du hast jetzt 30 Wunsch-Arbeitgeber eingetragen – mehr geht leider nicht. ',
    EP_IDEAL_EMPLOYER_NAVIGATION_TITLE: 'Wunsch-Arbeitgeber',
    EP_IDEAL_EMPLOYER_REMOVE: 'Doch kein Wunsch-Arbeitgeber?',
    EP_IDEAL_EMPLOYER_WORK: 'Würdest Du hier gern arbeiten?',
    EP_IMAGE_UPLOAD_SIZE_FORMAT_ERROR:
      'Dieses Bild geht leider nicht: Mögliche Formate sind JPG, JPEG oder PNG, die Maximalgröße beträgt 5 MB.',
    EP_INDUSTRY_SUBCATEGORY: 'Unterbereich',
    EP_INFO_LAST_STEP_CREATE_PAGE:
      '– In der Zwischenzeit können Sie bereits weitere Inhalte zu Ihrem Arbeitgeberprofil hinzufügen.',
    EP_INPUT_CHARS_LEFT: 'Noch {charactersNumber} Zeichen\n',
    EP_INSIDER_CHANGE_PROFILE_INFO_BUTTON: 'Profil besuchen',
    EP_INSIDER_CHANGE_PROFILE_INFO_TEXT:
      'Dein Profilbild und Hintergrundbild kannst Du in Deinem Profil anpassen.',
    EP_INVALID_COMPANY_NAME:
      "Eine XING Seite mit diesem Namen gibt's schon. Schauen Sie doch mal nach.",
    EP_JOB_ADS_FOUND: '{total} Stellenangebote gefunden',
    EP_JOB_JOBBOX: 'Gemerkte Jobs ansehen',
    EP_JOB_LOOKING: 'Auf Job-Suche?',
    EP_JOB_NO_VACANCIES: "Im Moment gibt's keine offenen Stellen.",
    EP_JOBS_CAREER_LEVEL: 'Karriere-Stufe',
    EP_JOBS_DAYSAGO: 'Vor {number} Tagen ',
    EP_JOBS_DESCRIPTION: 'Jobs',
    EP_JOBS_DISCIPLINE: 'Tätigkeitsfeld',
    EP_JOBS_EDIT_HINT:
      'Hier werden alle Stellenanzeigen angezeigt, die Sie bei XING geschaltet haben. ',
    EP_JOBS_EDITSWITCH_CTA: 'Zum XING JobManager',
    EP_JOBS_EDITSWITCH_DISCRIPTION:
      '... können Sie direkt im {jobManager}.\nDas geht übrigens am besten am großen Bildschirm.',
    EP_JOBS_EDITSWITCH_DISCRIPTION_INNER: 'XING JobManager',
    EP_JOBS_EDITSWITCH_HEADLINE: 'Stellenanzeigen schalten und verwalten',
    EP_JOBS_EMPTYSTATE_BODY:
      'Mit Ihrem neuen Jobangebot finden Sie auch die richtigen Mitarbeiter.',
    EP_JOBS_EMPTYSTATE_CTA: 'Neues Jobangebot hinzufügen',
    EP_JOBS_EMPTYSTATE_HEADER: 'Sie haben zurzeit keine offenen Stellen.',
    EP_JOBS_FEEDBACK_ERROR: 'Das hat leider nicht geklappt',
    EP_JOBS_FILTER_ALL: 'Alle',
    EP_JOBS_HEADLINE: 'Jobs',
    EP_JOBS_LINK: 'Alle jobs',
    EP_JOBS_LOCATIONS: 'Arbeitsorte',
    EP_JOBS_MATCH: '{number} % Übereinstimmung ',
    EP_JOBS_NAVIGATION_TITLE: 'Jobs',
    EP_JOBS_PUBLIC_EMPTYSTATE_BODY:
      'Bist Du auf Job-Suche? Dann guck Dir mal unsere Empfehlungen an.',
    EP_JOBS_PUBLIC_EMPTYSTATE_CTA: 'Empfehlungen anschauen',
    EP_JOBS_PUBLIC_EMPTYSTATE_HEADER: 'Zurzeit gibt es keine Job-Angebote.',
    EP_JOBS_RECOMMENDATION: 'Job-Vorschläge ansehen',
    EP_JOBS_SEARCH_PLACEHOLDER: 'Job-Titel oder Stichwort eingeben',
    EP_JOBS_SUBPAGE_DESCRIPTION:
      'Alle Jobangebote von {pageTitle} auf einen Blick',
    EP_JOBS_TODAY: 'Heute',
    EP_JOBS_YESTERDAY: 'Gestern',
    EP_JOIN_GROUP_CTA: 'Beitreten',
    EP_KUNUNU_ALL_BENEFITS: 'Alle Vorteile auf kununu',
    EP_KUNUNU_ALL_REVIEWS: 'Alle {number} Bewertungen auf kununu',
    EP_KUNUNU_BENEFITS_CONFIRMATION:
      'In {total} von {totalReviews} Bewertungen bestätigt',
    EP_KUNUNU_BENEFITS_TITLE: 'Vorteile für Mitarbeitende',
    EP_KUNUNU_CULTURE_BUTTON: 'Unternehmenskultur anzeigen',
    EP_KUNUNU_DISCOVER_REVIEWS:
      'Lerne das Unternehmen kennen und erfahre mehr über die Unternehmenskultur',
    EP_KUNUNU_DISCOVER_REVIEWS_CULTURE:
      'Lerne das Unternehmen kennen und erfahre mehr über seine Kultur.',
    EP_KUNUNU_EDIT_HINT:
      'Diese Bewertungen kommen direkt von Ihrem kununu-Profil.',
    EP_KUNUNU_EDIT_HINT_CTA: 'Zum kununu-Profil',
    EP_KUNUNU_HEADLINE: 'Bewertungen',
    EP_KUNUNU_NAVIGATION_TITLE: 'Bewertungen & Kultur',
    EP_KUNUNU_RATE_COMPANY:
      'Arbeitest Du hier – oder hast mal hier gearbeitet?',
    EP_KUNUNU_RATE_COMPANY_BUTTON: 'Arbeitgeber bewerten',
    EP_KUNUNU_RATING: 'Bewertung auf kununu',
    EP_KUNUNU_RATING_VALUE: '{value} / {fullValue}',
    EP_KUNUNU_READ_REVIEW: 'Bewertung lesen',
    EP_KUNUNU_RECOMMENDATION: 'empfehlen diesen Arbeitgeber',
    EP_KUNUNU_REVIEW_TITLE: 'Zitate von Mitarbeitenden',
    EP_KUNUNU_REVIEWER_CURRENT_JOB: 'Arbeitet hier',
    EP_KUNUNU_REVIEWER_FORMER_JOB: 'Hat hier gearbeitet',
    EP_KUNUNU_REVIEWER_INTERNSHIP_JOB: 'Praktikum',
    EP_KUNUNU_REVIEWER_NS_JOB: 'Keine Angabe',
    EP_KUNUNU_SHARE_BUTTON: 'Diesen Arbeitgeber bewerten',
    EP_KUNUNU_SHARE_DETAIL:
      'Teil Deine Erfahrungen mit anderen, natürlich anonym. ',
    EP_KUNUNU_SHARE_TITLE: 'Hast Du für {company} gearbeitet?',
    EP_KUNUNU_WHAT_SAY_BUTTON: 'Profil auf kununu ansehen',
    EP_LEARN_MORE_ABOUT_US: 'Alle Infos über uns',
    EP_LEGAL_NOTICE: 'Impressum',
    EP_LEGAL_NOTICE_EMPTY_STATE: 'Impressum',
    EP_LOAD_MORE_CTA: 'Weitere Beiträge',
    EP_LOCATION_ADDRESS_ERROR:
      'Diese Anschrift haben wir nicht gefunden – können Sie das nochmal prüfen?',
    EP_LOCATION_CITY_ERROR:
      'Diesen Ort haben wir nicht gefunden – können Sie das nochmal prüfen?',
    EP_LOCATION_EMAIL_ERROR:
      'Dies scheint keine E-Mail-Adresse zu sein ... vielleicht vertippt?',
    EP_LOCATION_EMPTY_STATE_BUTTON: 'Kontaktdaten eingeben',
    EP_LOCATION_EMPTY_STATE_TEXT:
      'Bitte geben Sie noch Ihre Anschrift und Kontaktdaten an. Danach können Sie Ihre Seite veröffentlichen.',
    EP_LOCATION_EMPTY_STATE_TITLE: 'Wo kann man Sie finden? Und wie erreichen?',
    EP_LOCATION_FAXNUMBER_ERROR:
      'Bitte geben Sie hier nur Ziffern ein (mind. 5).',
    EP_LOCATION_LABEL_ERROR:
      'Diesen Ort haben wir nicht erkannt – können Sie Ihre Eingabe nochmal prüfen?',
    EP_LOCATION_PHONENUMBER_ERROR:
      'Bitte geben Sie hier nur Ziffern ein (mind. 5).',
    EP_LOCATION_POSTCODE_ERROR: 'Bitte geben Sie hier keine Sonderzeichen ein.',
    EP_LOCATION_WEBSITE_ERROR:
      'Diese Web-Adresse haben wir nicht gefunden ... vielleicht vertippt?',
    EP_LOCATIONS_EDIT_TITLE: 'Standort bearbeiten',
    EP_LOCATIONS_HEADLINE: 'Standort',
    EP_LOCATIONS_NAVIGATION_TITLE: 'Ort',
    EP_LOCATIONS_OPEN_MAP: 'Größere Karte',
    EP_MAIL_LAST_STEP_CREATE_PAGE:
      '– Wir senden die Bestätigungs-Mail an die folgende E-Mail-Adresse: {mail}',
    EP_MANAGE_CONTENT: 'Medien verwalten',
    EP_MAX: 'Max.',
    EP_MEDIA_HEADLINE: 'Impressionen',
    EP_MEMBERS_BLOCKED_MEMBER_LEAVE_BODY:
      'Du bist dann kein Mitglied mehr und kannst der Gruppe auch nicht wieder beitreten.',
    EP_MEMBERS_BLOCKED_MEMBER_LEAVE_HEADLINE:
      'Möchtest Du die Gruppe verlassen?',
    'EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.one': '{value} gemeinsamer Kontakt',
    'EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.other': '{value} gemeinsame Kontakte',
    'EP_MEMBERS_CARD_SHARED_CONTACTS_WEB.zero': 'Keine gemeinsamen Kontakte',
    EP_MEMBERS_DESCRIPTION: 'Mitglieder',
    EP_MEMBERS_FEEDBACK_ERROR:
      "Das hat gerade leider nicht geklappt. Versuch's bitte gleich nochmal.",
    EP_MEMBERS_HEADLINE: 'Mitglieder',
    EP_MEMBERS_LEAVE_GROUP_NO: 'Abbrechen',
    EP_MEMBERS_LEAVE_GROUP_YES: 'Gruppe verlassen',
    EP_MEMBERS_MEMBER_LEAVE_BODY:
      'Du bist dann kein Mitglied mehr, kannst der Gruppe später aber wieder beitreten.',
    EP_MEMBERS_MEMBER_LEAVE_HEADLINE: 'Möchtest Du die Gruppe verlassen?',
    EP_MEMBERS_MODERATOR_LEAVE_BODY:
      'Du bist dann kein Mitglied mehr und verlierst alle Moderations-Rechte, kannst der Gruppe später aber wieder beitreten.',
    EP_MEMBERS_MODERATOR_LEAVE_HEADLINE: 'Möchtest Du die Gruppe verlassen?',
    EP_MEMBERS_NAVIGATION_TITLE: 'Mitglieder',
    EP_MEMBERS_OR: 'oder',
    EP_META_ABOUT_US_DESCRIPTION:
      '► Was zeichnet {pageTitle} als Arbeitgeber aus? Wie ist es, dort zu arbeiten? Das Unternehmen stellt sich Dir vor.',
    EP_META_ABOUT_US_TITLE: 'Über {pageTitle} | XING',
    EP_META_COMPANY_DESCRIPTION:
      '► Alles über {pageTitle} als Arbeitgeber: Informationen, Neuigkeiten, offene Stellen, Ansprechpersonen, Standorte und mehr',
    EP_META_CONTACTS_DESCRIPTION:
      'Ansprechpersonen für alle Anliegen an den Arbeitgeber {pageTitle}',
    EP_META_CONTACTS_TITLE: 'Ansprechpersonen von {pageTitle} | XING',
    EP_META_DESCRIPTION_COMPANY_PAGES:
      "Was zeichnet {pageTitle} als Arbeitgeber aus? Hier erfährst Du's.",
    EP_META_DESCRIPTION_DEFAULT:
      'Infos, aktuelle Neuigkeiten und offene Jobs von {pageTitle} – direkt auf XING.',
    EP_META_DESCRIPTION_PUBLISHER_PAGES:
      'Die besten Artikel von {pageTitle} – einfach folgen, direkt auf XING.',
    EP_META_DESCRIPTION_TOPIC_PAGES:
      'Das Neueste zum Thema {pageTitle} – einfach folgen, direkt auf XING.',
    EP_META_DISCUSSIONS_DESCRIPTION:
      '✅  Aktuelle Themen und Diskussionen der Gruppe {pageTitle}.',
    EP_META_DISCUSSIONS_TITLE: '{pageTitle}: Diskussionen | XING',
    EP_META_EMPLOYEES_DESCRIPTION:
      '► Mitarbeitende von {pageTitle} bei XING. Wenn kennst Du schon – und seid Ihr schon vernetzt? Wenn nicht, lernt Euch kennen und tauscht Euch zu gemeinsamen Themen aus.',
    EP_META_EMPLOYEES_TITLE: 'Mitarbeitende von {pageTitle} | XING',
    EP_META_EVENTS_DESCRIPTION:
      '✅ Hier siehst Du alle Gruppen-Events von {pageTitle}. Tausch Dich aus, vernetz Dich oder lern andere Mitglieder kennen.',
    EP_META_EVENTS_TITLE: 'Alle Gruppen-Events von {pageTitle} | XING',
    EP_META_JOBS_DESCRIPTION:
      '✅ Auf Job-Suche? Hier siehst Du aktuelle Stellenangebote von {pageTitle}. Informier Dich auch über Vorteile für Mitarbeitende und bewirb Dich direkt.',
    EP_META_JOBS_TITLE: 'Offene Stellen bei {pageTitle} | XING',
    EP_META_MEMBERS_DESCRIPTION:
      '✅ Schau nach, wer schon dabei ist, und erweiter Dein Netzwerk.',
    EP_META_MEMBERS_TITLE: 'Mitglieder der Gruppe {pageTitle} | XING',
    EP_META_NEWS_DESCRIPTION:
      "► Was gibt's Neues und Interessantes bei {pageTitle}? Hier erfährst Du's – aus erster Hand. Folge jetzt der XING Seite von {pageTitle}.",
    EP_META_NEWS_TITLE: 'Neuigkeiten und Infos von {pageTitle} | XING',
    EP_META_PAGE_TITLE: '{pageTitle}: Informationen und Neuigkeiten | XING',
    EP_META_WEBSITE_ERROR:
      'Dies scheint keine Website zu sein ... vielleicht vertippt?',
    EP_META_YEAR_LABEL_ERROR:
      'Dies scheint kein Jahr zu sein ... vielleicht vertippt?',
    EP_MIN: 'Mind.',
    EP_MODULE_DISCUSSION_EDITOR_TAB_HIDDEN: 'Ausgeblendet',
    EP_MODULE_DISCUSSION_EDITOR_TAB_PUBLISHED: 'Veröffentlicht',
    EP_MODULE_DISCUSSION_SHOW_MORE: 'Mehr anzeigen',
    EP_MODULE_DISCUSSION_TITLE: 'Diskussionen',
    EP_MODULE_DISCUSSIONS_ALL_LINK: 'Alle Beiträge',
    EP_MODULE_ERROR_SUBLINE:
      'Bitte versuch es nochmal oder geh zur {overview} zurück.',
    EP_MODULE_ERROR_SUBLINE_INNER: '{entityPage} Überblick',
    EP_NA: 'Keine Angabe',
    EP_NAVIGATION_ARIA_LABEL: 'Seitenkomponenten Navigation',
    EP_NAVIGATION_EDIT_HINT:
      'Die Sichtbarkeit und Reihenfolge der Tabs können Sie im XING BrandManager ändern.',
    EP_NAVIGATION_EDIT_HINT_CTA: 'BrandManager öffnen',
    EP_NEW_PAGE_CREATED_DRAFT:
      'Dieses Arbeitgeberprofil befindet sich im Entwurfsmodus und ist noch nicht veröffentlicht.',
    EP_NEWS_ACTION_TYPE_ARTICLE: 'hat diesen Artikel geteilt.',
    EP_NEWS_ACTION_TYPE_IMAGE: 'hat dieses Bild geteilt.',
    EP_NEWS_ACTION_TYPE_LINK: 'hat diesen Link geteilt.',
    EP_NEWS_ACTION_TYPE_TEXT: 'hat einen Beitrag geschrieben.',
    EP_NEWS_ACTION_TYPE_VIDEO: 'hat dieses Video geteilt.',
    EP_NEWS_DESCRIPTION: 'Neuigkeiten',
    EP_NEWS_HEADLINE: 'Neuigkeiten',
    EP_NEWS_MODULE_EDIT_ALL: 'Neuigkeiten verwalten',
    EP_NEWS_NAVIGATION_TITLE: 'Neuigkeiten',
    EP_NEWS_SHOW_ALL: 'Alle Neuigkeiten',
    EP_NEWS_SUBPAGE_DESCRIPTION:
      'Alle Neuigkeiten von {pageTitle} auf einen Blick',
    EP_NEWS_UPSELL_POPOVER_BODY:
      'Ein angehefteter Artikel erscheint immer an oberster Stelle Ihrer Neuigkeiten. Damit heben Sie Beiträge hervor, die besondere Aufmerksamkeit verdienen.',
    EP_NEWS_UPSELL_POPOVER_BUTTON: 'Alle Vorteile entdecken',
    EP_NEWS_UPSELL_POPOVER_HEADER: 'Top-Artikel anheften',
    EP_NEXT_BUTTON_LAST_STEP_CREATE_PAGE: 'Arbeitgeberprofil weiter bearbeiten',
    EP_NO_DOCUMENTS:
      'Bieten Sie Ihren Seitenbesuchern hier z. B. Produkt-Infos, Jahresberichte oder Firmen-Zeitschriften.',
    EP_NO_DOCUMENTS_HEADLINE: 'Hier ist Platz für Ihre PDF-Dokumente.',
    EP_OF_CONTACTS: 'Deiner Kontakte',
    EP_ON_XING: 'auf XING',
    EP_OPTIONAL_FIELD_HINT: 'Optional',
    EP_OPTIONS: 'Was möchtest Du tun?',
    EP_PAGE_CREATION_ABOUT_US_SUBHEADER:
      'Titel und Beschreibung erscheinen auf Eurem Arbeitgeberprofil unter „Über uns“. Beides ist notwendig für die Freigabe und kann in Eurem Profil noch angepasst werden.',
    EP_PAGE_CREATION_BACK_TO_COMPANIES: 'Zurück zur Übersicht',
    EP_PAGE_CREATION_CLOSE: 'Ja, löschen',
    EP_PAGE_CREATION_CLOSE_PROCESS:
      'Möchten Sie das Profil {name} wirklich löschen?',
    EP_PAGE_CREATION_COMPANY_NAME_HELPER:
      'Bitte achten Sie auf die richtige Schreibweise Ihres Unternehmens, da diese Eingabe nicht mehr rückgängig gemacht werden kann.',
    EP_PAGE_CREATION_CONDITIONS:
      'Ich bin berechtigt, diese XING Seite zu erstellen, und akzeptiere die <a href="https://www.xing.com/terms/employer-branding-profil" target="_blank">AGB für XING Unternehmensprofile</a>.',
    EP_PAGE_CREATION_CONTACTS_INFO:
      'Die Kontaktdaten Ihres Unternehmens werden auf dem Arbeitgeberprofil veröffentlicht. ',
    EP_PAGE_CREATION_DELETE_PROFILE: 'Profilentwurf löschen',
    EP_PAGE_CREATION_DIALOG_CLOSE: 'Prozess beenden',
    EP_PAGE_CREATION_DIALOG_TEXT:
      'Möchten Sie den Prozess wirklich beenden? Ihre Eingaben auf dieser Seite gehen dann verloren.',
    EP_PAGE_CREATION_DO_NOT_CLOSE: 'Abbrechen',
    EP_PAGE_CREATION_FORM_1_TITLE: 'Das Wichtigste zu Ihrem Unternehmen',
    EP_PAGE_CREATION_RESUME_OR_DELETE:
      'Schließen Sie bitte die Erstellung Ihres Arbeitgeberprofils ab und übermitteln Sie uns die Daten zur Prüfung. Wenn Sie von Neuem starten möchten, löschen Sie dieses Profil bitte.',
    EP_PAGE_CREATION_SAVE_NEXT: 'Speichern und weiter',
    EP_PAGE_CREATION_SEND_FOR_APPROVAL: 'Freigabe beantragen',
    EP_PAGE_INFO_HELP_BODY:
      'Im Hilfebereich finden Sie viele hilfreiche Tipps zum Einrichten Ihrer XING Seite.',
    EP_PAGE_INFO_HELP_CTA: 'Zum Hilfebereich',
    EP_PAGE_INFO_HELP_TITLE: 'Fragen?',
    EP_PAGE_INFO_MANAGE_BODY:
      'Im BrandManager können Sie Module hinzufügen, verbergen oder umsortieren.',
    EP_PAGE_INFO_MANAGE_CTA: 'BrandManager öffnen',
    EP_PAGE_INFO_MANAGE_TITLE: 'Module verwalten',
    EP_PAGE_INFO_PAGE_TYPE_FREE: 'Gratisprofil',
    EP_PAGE_INFO_PAGE_TYPE_LABEL: 'Seitentyp',
    EP_PAGE_INFO_PAGE_TYPE_PAID: 'Employer Branding Page',
    EP_PAGE_INFO_PAGE_TYPE_PAID_PLUS: 'Employer Branding Page Professional',
    EP_PAGE_INFO_ROLE_ADMINISTRATOR: 'Admin',
    EP_PAGE_INFO_ROLE_EDITOR: 'Editor',
    EP_PAGE_INFO_ROLE_LABEL: 'Ihre Rolle:',
    EP_PAGE_INFO_ROLE_OWNER: 'Eigentümer',
    EP_PAGE_INFO_TITLE: 'Infos zur Seite',
    EP_PAGE_OWNER: 'Seiten-Editor ',
    EP_PARAMS_INCORRECT_ERROR:
      'Bitte gib noch den Titel und die Beschreibung ein (jeweils mind. 4 Zeichen).',
    EP_PENDING_GROUP_JOIN_INFO: 'Zu bestätigen',
    EP_PROMOTE_PAGE: 'Seite bewerben',
    EP_PUBLISH_CTA: 'Speichern',
    EP_READ_LESS: 'Weniger anzeigen',
    EP_READ_MORE: 'Weiterlesen',
    EP_READ_MORE_CTA: 'Weiterlesen',
    EP_REPORT_NEWS_ITEM: 'Melden',
    EP_REPORT_PAGE: 'Seite melden',
    EP_REQUIRED_FIELD: 'Pflichtfeld',
    EP_RESTORE_CTA: 'Wiederherstellen',
    EP_RESULT_LIST_CONTACT:
      'War die richtige Ansprechperson nicht dabei? Wir helfen Ihnen gerne weiter:  <a href="mailto:customer.support@xing.com">customer.support@xing.com</a>',
    EP_RESULT_LIST_CONTACT_V2:
      'War die richtige Ansprechperson nicht dabei? Wir helfen Ihnen gerne weiter:  <a>customer.support@xing.com</a>',
    EP_RESULT_LIST_HEADLINE: 'Ansprechperson auswählen',
    EP_ROLLOUT_BANNER_ADD_LEGAL_NOTICE: 'Ihr Impressum',
    EP_ROLLOUT_BANNER_CONFIRM_BUTTON: 'Zum neuen Design wechseln ',
    EP_ROLLOUT_BANNER_CONTACT_DETAILS: 'Kontaktdaten Ihres Unternehmens',
    EP_ROLLOUT_BANNER_CONTACT_DETAILS_DESCRIPTION:
      'Bitte geben Sie hier die Adresse sowie Telefonnummer Ihres Unternehmens an.',
    EP_ROLLOUT_BANNER_DESCRIPTION:
      'Ihr neues Arbeitgeberprofil steht in den Startlöchern.\nPrüfen Sie bitte zunächst die folgenden Angaben auf Vollständigkeit und ändern Sie diese, falls nötig:',
    EP_ROLLOUT_BANNER_LEGAL_ADVICE_DESCRIPTION:
      'Bitte geben Sie hier den Link zum Impressum Ihrer Unternehmens-Website an oder tragen Sie diese Information manuell ein.',
    EP_ROLLOUT_BANNER_MOBILE_INFO:
      'Öffnen Sie Ihr Arbeitgeberprofil bitte auf dem Desktop, bevor Sie zum neuen Design wechseln.',
    EP_ROLLOUT_BANNER_OLD_URL:
      'Besucher Ihres alten Arbeitgeberprofils werden zukünftig umgeleitet.',
    EP_ROLLOUT_BANNER_PROFILE_UPDATED:
      'Willkommen auf Ihrem neuen Arbeitgeberprofil!',
    EP_ROLLOUT_BANNER_PUBLISH_INFO:
      'Alles geprüft? Prima, dann können Sie zum neuen Design wechseln:',
    EP_ROLLOUT_BANNER_TEXT_EMAIL:
      'Haben Sie Fragen? Wir helfen Ihnen gerne weiter:\n<br/>\nE-Mail: <a href="mailto:customer.support@xing.com">customer.support@xing.com</a>\n<br/>\nTelefon: +49 40 419 131 778',
    EP_ROLLOUT_BANNER_TITLE: 'Sie haben es fast geschafft!',
    EP_ROLLOUT_BANNER_UPDATED_URL:
      'Der Link zu Ihrer XING Seite ist jetzt <strong>www.xing.com/pages/{slug}</strong>.',
    EP_ROLLOUT_BANNER_WEBINAR_LINK:
      'https://attendee.gotowebinar.com/rt/2071891534032487180',
    EP_ROLLOUT_PUBLISH_ERROR_ABOUT_US:
      'Bitte fügen Sie jetzt noch Ihre ausführliche Beschreibung für die Rubrik "Über uns" hinzu.',
    EP_ROLLOUT_PUBLISH_ERROR_LOCATION:
      'Bitte fügen Sie noch die Kontaktdaten Ihres Unternehmens hinzu.',
    EP_ROLLOUT_WEBINAR_TEXT_1:
      'Lust auf einen Rundgang durch Ihre neue XING Seite? Oder haben Sie bestimmte Fragen? Dann registrieren Sie sich gern für eines unserer',
    EP_ROLLOUT_WEBINAR_TEXT_2: 'Registrieren Sie sich für eines unserer',
    EP_ROLLOUT_WEBINAR_TEXT_LINK: 'Live-Webinare',
    EP_SEE_ALL_AWARDS: 'Alle Auszeichnungen',
    EP_SELECT_NONE: 'Nichts davon',
    EP_SHARE_PAGE: 'Seite teilen',
    EP_SHOW_ALL_RESULTS: 'Alle Ergebnisse',
    EP_SHOW_MORE_RESULTS: 'Weitere Ergebnisse ',
    EP_SIMILAR_JOBS_HEADLINE: 'Ähnliche Jobs',
    EP_SLOGAN_EDIT_HEADLINE: 'Slogan bearbeiten',
    EP_SLOGAN_EDIT_HEADLINE_INFO:
      'Füg hier Euren Slogan hinzu – oder die Essenz Eurer Seite in wenigen Worten.',
    EP_SLOGAN_EDIT_HINT:
      'Hier steht der Slogan Ihrer Seite, z. B. Ihr Firmenslogan.',
    EP_SLOGAN_EDIT_LABEL: 'Slogan der Seite',
    EP_SOME_JOB_ADS_FOUND: 'Alle passenden Stellenangebote',
    EP_SUBPAGE_BACK: 'Zur Übersicht',
    EP_TELEPHONE: 'Telefon',
    EP_TITLE_EDIT_HINT: 'Als Seitentitel eignet sich oft der Firmen-Name.',
    EP_TITLE_EDIT_LABEL: 'Titel der Seite',
    EP_UNFOLLOW: 'Nicht mehr folgen',
    EP_UPDATES_EDIT_EMPTY_STATE_DESCRIPTION:
      'Mit jedem neuen Beitrag machst Du XING Mitglieder auf Deine Seite aufmerksam.',
    EP_UPDATES_EDIT_EMPTY_STATE_HEADLINE:
      'Füg hier Deinen ersten Artikel hinzu.',
    EP_UPDATES_PUBLIC_EMPTY_STATE_DESCRIPTION:
      'Folge der Seite, damit du immer auf dem neuesten Stand bleibst.',
    EP_UPDATES_PUBLIC_EMPTY_STATE_HEADLINE:
      'Sobald es Neuigkeiten gibt, siehst Du sie hier.',
    EP_UPLOAD_COVER: 'Titelbild auswählen',
    EP_UPLOAD_COVER_LABEL:
      'Wählen Sie ein eindrucksvolles Hintergrundbild für Ihre XING Seite.',
    EP_UPLOAD_DOCUMENT: 'PDF hinzufügen',
    EP_UPLOAD_IMAGE_DRAG_LABEL: 'Logo-Datei hier ablegen',
    EP_UPLOAD_IMAGE_HINT: 'JPG, BMP oder PNG (max. 5 MB) im Format 16:9',
    EP_UPLOAD_IMAGE_LABEL: 'Datei hierher ziehen oder auswählen',
    EP_UPLOAD_LOGO: 'Neues Logo hinzufügen',
    EP_UPLOAD_LOGO_DRAG_LABEL: 'Sie können Ihr Logo hier ablegen.',
    EP_UPLOAD_LOGO_EDIT_INFO:
      'Tipps für ein perfektes Logo auf Deiner XING Seite gefällig?',
    EP_UPLOAD_LOGO_EDIT_INFO_CTA: 'Tipps lesen',
    EP_UPLOAD_LOGO_HINT: 'JPG, BMP oder PNG (max. 5 MB), Format: Quadrat',
    EP_UPLOAD_LOGO_LABEL: 'Datei hierher ziehen oder auswählen',
    EP_UPSELL_BANNER_CONTAINER_DISCARD_BUTTON: 'Verwerfen',
    EP_UPSELL_BANNER_CONTAINER_PUBLISH_BUTTON: 'Weiter',
    EP_UPSELL_BODY_TOP_HEADER:
      'Begrüßen Sie Besucher·innen Ihres Arbeitgeberprofils mit Ihrem eigenen Titelbild und Slogan. Dadurch steigern Sie Ihren Wiedererkennungswert als Marke und erreichen Ihre Zielgruppe zuverlässig mit Ihrer Botschaft.\n \nZeigen Sie allen, wofür Ihr Unternehmen steht!',
    EP_UPSELL_COMPANY_RECOMMENDED_BODY:
      'Schließen Sie mit dem Upgrade alle Empfehlungen für fremde Unternehmen auf Ihrem eigenen Arbeitgeberprofil aus. So liegt der Fokus allein auf Ihnen.',
    EP_UPSELL_COMPANY_RECOMMENDED_HEADER: 'Weniger ist mehr!',
    EP_UPSELL_CONTACT_BODY:
      'Fügen Sie auf Ihrem Arbeitgeberprofil mehrere Ansprechpersonen hinzu, damit Ihre Besucher·innen immer den richtigen Kontakt für Ihre Anfragen finden.',
    EP_UPSELL_CONTACT_HEADER: 'Immer die richtige Ansprechperson',
    EP_UPSELL_DOCUMENTS:
      'Stellen Sie nützliche Dokumente wie offizielle Firmenpräsentationen, Tipps, Handbücher und ähnliches zur Verfügung und nutzen Sie Ihr Arbeitgeberprofil als zentralen Ort für relevante Informationen für Ihre Besucher.',
    EP_UPSELL_DOCUMENTS_HEADER: 'Alle relevanten Infos an einem zentralen Ort',
    EP_UPSELL_DOCUMENTS_HEADLINE: 'Dokumente hinzufügen',
    EP_UPSELL_EMPLOYER_FLAG_BUTTON: 'Employer Branding Profil',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_BODY:
      'Diesen und mehr Vorteile gibt’s beim Employer Branding Profil. <br / >\nMit Klick auf den Stift <strong>Bild wählen</strong> und in die <strong>richtige Position</strong> rücken. Mit einem Upgrade kannst Du’s veröffentlichen.',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_BODY_WITH_IMAGE:
      'Aktuell ist es aber nur für Dich sichtbar – eigentlich schade, oder? <br />\nSicher Dir das Upgrade, damit auch andere es sehen können.',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_BUTTON: 'Upgrade',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_HEADER: 'Hier ist Platz für ein Titelbild!',
    EP_UPSELL_EMPLOYER_FLAG_CONTENT_HEADER_WITH_IMAGE:
      'Dein Titelbild sieht gut aus!',
    EP_UPSELL_GALLERY_ABOUT_US:
      'Gestalten Sie Ihr Arbeitgeberprofil interessant und einzigartig. Nutzen Sie Ihre ganz persönlichen Gestaltungsmöglichkeiten durch Bilder und Videos aus Ihrem Unternehmen, von Ihrem Team oder Ihrem Produkt.',
    EP_UPSELL_GALLERY_ABOUT_US_HEADER: 'Überzeugen Sie auf allen Wegen.',
    EP_UPSELL_GALLERY_BUTTON: 'Vorteile entdecken',
    EP_UPSELL_HEADER_TOP_HEADER: 'Mit Titelbild & Slogan neue Talente gewinnen',
    EP_UPSELL_PROFILE_MULTIMEDIA_BODY:
      'Gestalten Sie Ihr Arbeitgeberprofil interessant und einzigartig. Nutzen Sie Ihre ganz persönlichen Gestaltungsmöglichkeiten: durch Bilder und Videos aus Ihrem Unternehmen, von Ihrem Team oder Ihrem Produkt.',
    EP_UPSELL_PROFILE_MULTIMEDIA_HEADER: 'Eigene Videos und Bilder',
    EP_VISIT_WEBSITE: 'Website',
    EP_VISIT_WEBSITE_EMPTY_STATE: 'Webseite',
    EP_WHO_TO_CONTACT: 'Unsere Ansprechpersonen',
    EP_YOUR_TOPICS_EDIT_VIEW_CANCEL: 'Abbrechen',
    EP_YOUR_TOPICS_EDIT_VIEW_COPY:
      'Um von Deinen Leser·innen besser gefunden zu werden, gib hier bitte die Themenbereiche an, über die Du schreibst. Du kannst bis zu vier Kategorien wählen oder erstellen.',
    EP_YOUR_TOPICS_EDIT_VIEW_LABEL: 'Thema hinzufügen',
    EP_YOUR_TOPICS_EDIT_VIEW_SAVE: 'Speichern',
    EP_YOUR_TOPICS_EDIT_VIEW_TITLE: 'Deine Themenbereiche',
    'EP-ARTICLES-MODULE-EMPTY-STATE-EDIT-TEXT':
      'Nutz den XING Editor, um einen neuen Artikel zu schreiben. Du kannst auch einen externen Artikel von Dir via Link teilen.',
    'EP-ARTICLES-MODULE-EMPTY-STATE-EDIT-TITLE':
      'Zeit für Deinen ersten Artikel',
    'EP-ARTICLES-MODULE-EMPTY-STATE-PINNED-TEXT':
      'Du kannst einen Deiner Artikel an den Anfang Deiner Sammlung pinnen. Das geht mit dem Stern-Button.',
    'EP-ARTICLES-MODULE-EMPTY-STATE-PINNED-TITLE':
      'Setz Deinen besten Artikel in Szene',
    'EP-ARTICLES-MODULE-EMPTY-STATE-TEXT':
      'Du kannst der Seite folgen. Dann benachrichtigen wir Dich, falls es etwas Neues gibt.',
    'EP-ARTICLES-MODULE-EMPTY-STATE-TITLE':
      'Bis jetzt wurden hier keine Artikel veröffentlicht.',
    'EP-ARTICLES-MODULE-FILTER-ALL': 'Alle Artikel',
    'EP-ARTICLES-MODULE-FILTER-DRAFTS': 'Entwurf',
    'EP-ARTICLES-MODULE-FILTER-HIDDEN': 'Ausgeblendet',
    'EP-ARTICLES-MODULE-FILTER-PUBLISHED': 'Veröffentlicht',
    'EP-ARTICLES-MODULE-FILTER-SCHEDULED': 'Geplant',
    'EP-ARTICLES-MODULE-MOBILE-HINT-TEXT':
      'Auf mobilen Geräten funktioniert der Editor leider nicht.',
    'EP-ARTICLES-MODULE-MOBILE-HINT-TITLE': 'Bitte benutze einen Computer',
    'EP-ARTICLES-MODULE-SHARE-NEW-ARTICLE-BUTTON': 'Externen Artikel teilen',
    'EP-ARTICLES-MODULE-SHOW-MORE-ARTICLES-BUTTON': 'Mehr Artikel anzeigen',
    'EP-ARTICLES-MODULE-WRITE-NEW-ARTICLE-BUTTON': 'Artikel schreiben',
    FEEDY_CARD_VERB_CONTENT_PAGE_ARTICLE_POST:
      'hat einen Artikel veröffentlicht',
    FEEDY_CARD_VERB_IMAGE_POST: 'hat dieses Bild geteilt',
    FEEDY_CARD_VERB_LINK_POST: 'hat diesen Link geteilt',
    FEEDY_CARD_VERB_STATUS_POST: 'hat einen Beitrag geschrieben',
    IMAGE_UPLAD_READY_CTA: 'Dateien durchsuchen',
    INDUSTRY: 'Branche',
    INSIDER_DESCRIPTION_INTRO: 'Schreibt über',
    'JOBS_DATE_DAYS_LEFT_LABEL.one': 'Noch {variable_1} Tag',
    'JOBS_DATE_DAYS_LEFT_LABEL.other': 'Noch {variable_1} Tage',
    JOBS_DATE_EXPIRING_TODAY_LABEL: 'Nur noch heute',
    JOBS_JOB_TEASER_SAVE: 'Job merken',
    JOBS_NEW_JOB_LABEL: 'Neu',
    JOBS_TIMESTAMP_30_PLUS_DAYS_AGO: 'Vor 30+ Tagen',
    JOBS_TIMESTAMP_30_PLUS_DAYS_AGO_A11Y: 'Vor über 30 Tagen veröffentlicht',
    JOBS_TIMESTAMP_JUST_NOW: 'Gerade eben',
    JOBS_TIMESTAMP_JUST_NOW_A11Y: 'Gerade veröffentlicht',
    JOBS_TIMESTAMP_N_DAYS_AGO: 'Vor {number} Tagen',
    JOBS_TIMESTAMP_N_DAYS_AGO_A11Y: 'Vor {number} Tagen veröffentlicht',
    JOBS_TIMESTAMP_N_HOURS_AGO:
      '{number, plural, =1 {Vor 1 Stunde} other {Vor # Stunden}}',
    JOBS_TIMESTAMP_N_HOURS_AGO_A11Y:
      '{number, plural, =1 {Vor einer Stunde veröffentlicht} other {Vor # Stunden veröffentlicht}}',
    JOBS_TIMESTAMP_YESTERDAY: 'Gestern',
    JOBS_TIMESTAMP_YESTERDAY_A11Y: 'Gestern veröffentlicht',
    JS_REALLY: 'Willst Du das wirklich?',
    JS_REALLY_DELETE: 'Wirklich löschen?',
    LIKE_BUTTON_LABEL: 'Gefällt mir',
    LIKERS_LIST_HEADLINE: 'Diesen Mitgliedern gefällt das:',
    LINKCAP_LIST: 'Liste',
    LOGGEDOUT_BUTTON_ADDCONTACT: '{-display_name} als Kontakt hinzufügen',
    MALT_IMAGE_UPLOAD_BROWSE_BUTTON: 'Datei auswählen',
    MESSAGESHTML_SEARCH_INBOX: 'Suche nach Namen',
    MESSENGER_SHARE_COMMENT_PLACEHOLDER:
      'Hier kannst Du Deinen Link kommentieren.',
    MESSENGER_SHARE_RECEIPENT_SELECTION_FORM_LABEL: 'Empfänger:',
    MESSENGER_SHARE_RECEIPENT_SELECTION_PLACEHOLDER: 'Empfänger eingeben',
    MESSENGER_SHARE_TARGET_LABEL: 'Deine Nachricht:',
    MOB_ENTITY_PAGES_JOBS_MODULE_SUBPAGE_UNLOCK: 'Top-Jobs freischalten',
    MONTH_NAMES:
      'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember',
    MONTH_NAMES_SHORT: 'Jan,Feb,Mär,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez',
    NAVIGATION_EXPAND_NETWORK_ADDITION: 'Jetzt ausprobieren!',
    NEWS_MODULE_DELETE_LABEL: 'Löschen',
    NEWS_MODULE_DIALOG_DELETE_HEADLINE: 'Artikel löschen?',
    NEWS_MODULE_DIALOG_DELETE_NO: 'Nein',
    NEWS_MODULE_DIALOG_DELETE_TEXT:
      'Soll dieser Artikel wirklich für immer gelöscht werden?',
    NEWS_MODULE_DIALOG_DELETE_YES: 'Ja, löschen',
    NEWS_MODULE_DIALOG_HIDE_HEADLINE: 'Artikel ausblenden?',
    NEWS_MODULE_DIALOG_HIDE_NO: 'Nein',
    NEWS_MODULE_DIALOG_HIDE_TEXT: 'Er ist dann auf XING nicht mehr auffindbar.',
    NEWS_MODULE_DIALOG_HIDE_YES: 'Ja, ausblenden',
    NEWS_MODULE_DIALOG_PIN_HEADLINE: 'Top-Artikel anheften?',
    NEWS_MODULE_DIALOG_PIN_NO: 'Nein',
    NEWS_MODULE_DIALOG_PIN_TEXT:
      'Soll dieser Artikel immer an oberster Postion erscheinen?',
    NEWS_MODULE_DIALOG_PIN_YES: 'Ja, ab nach oben ',
    NEWS_MODULE_DIALOG_UNPIN_HEADLINE: 'Nicht mehr anheften?',
    NEWS_MODULE_DIALOG_UNPIN_NO: 'Oben belassen',
    NEWS_MODULE_DIALOG_UNPIN_TEXT:
      'Möchten Sie diesen Artikel von der obersten Position entfernen?',
    NEWS_MODULE_DIALOG_UNPIN_YES: 'Ja, entfernen',
    NEWS_MODULE_DRAFT_LABEL: 'Entwurf',
    NEWS_MODULE_DRAFT_TAB: 'Entwürfe',
    NEWS_MODULE_EDIT_ALL: 'Alle Neuigkeiten bearbeiten',
    NEWS_MODULE_EDIT_LABEL: 'Bearbeiten',
    NEWS_MODULE_EMPTY_STATE_DESCRIPTION:
      'Du kannst der Seite einfach folgen, um keine zukünftigen Updates zu verpassen.\t',
    NEWS_MODULE_EMPTY_STATE_TITLE:
      'Hier findest Du Deine wichtigsten Neuigkeiten.',
    NEWS_MODULE_EMPTYSTATE_DESCRIPTION:
      'Mit jedem neuen Beitrag machen Sie XING Mitglieder auf Ihre Seite aufmerksam.',
    NEWS_MODULE_EMPTYSTATE_TITLE: 'Fügen Sie hier Ihren ersten Artikel hinzu.',
    NEWS_MODULE_HIDDEN_LABEL: 'Ausgeblendet',
    NEWS_MODULE_HIDDEN_TAB: 'Ausgeblendet',
    NEWS_MODULE_HIDE_BUTTON: 'Ausblenden',
    NEWS_MODULE_PIN_BUTTON: 'Anheften',
    NEWS_MODULE_PINNED_LABEL: 'Angeheftet',
    NEWS_MODULE_PROMOTE_BUTTON: 'Bewerben',
    NEWS_MODULE_PROMOTE_LABEL: 'Gesponsert',
    NEWS_MODULE_PUBLISH_FIRST_ARTICLE_BODY:
      'Dieses Modul wird dann für Seitenbesucher sichtbar.',
    NEWS_MODULE_PUBLISH_FIRST_ARTICLE_TITLE:
      'Veröffentlichen Sie jetzt Ihren ersten Artikel.',
    NEWS_MODULE_PUBLISHED_STORY_LABEL: 'Veröffentlicht',
    NEWS_MODULE_PUBLISHED_TAB: 'Veröffentlicht',
    NEWS_MODULE_SCHEDULE_LABEL: 'Geplant',
    NEWS_MODULE_SCHEDULED_TAB: 'Terminiert',
    NEWS_MODULE_SHOW_BUTTON: 'Einblenden',
    NEWS_MODULE_SHOW_STATISTICS: 'Statistiken ansehen',
    NEWS_MODULE_TOP_AREA_CTA: 'Einen Artikel auswählen',
    NEWS_MODULE_TOP_AREA_HEADLINE:
      'Sie haben noch keinen Top-Artikel ausgewählt.',
    NEWS_MODULE_TOP_AREA_SUB:
      'Per Klick auf das Sternsymbol können Sie einen Artikel aus Ihrer Sammlung hier prominent hervorheben.',
    NEWS_MODULE_TOP_LABEL: 'Top-Artikel',
    NEWS_MODULE_UNPIN_BUTTON: 'Nicht mehr anheften',
    NEWS_MODULE_UNPIN_LABEL: 'Nicht mehr anheften',
    POLLS_HEADER_LABEL: 'Umfrage',
    POLLS_SHOW_RESULT_TITLE: 'Ergebnisse ansehen',
    POLLS_SHOW_VOTING_OPTIONS_TITLE: 'Antwort-Optionen ansehen',
    POLLS_TIME_ENDED: 'Umfrage geschlossen',
    POLLS_TIME_LAST_MINUTES: 'Umfrage schließt bald!',
    'POLLS_TIME_REMAINING_DAYS_IOS.one': 'Endet morgen',
    'POLLS_TIME_REMAINING_DAYS_IOS.other': 'Endet in %d Tagen',
    'POLLS_TIME_REMAINING_DAYS_IOS.zero': 'Endet heute',
    'POLLS_TIME_REMAINING_DAYS_WEB.one': 'Endet morgen',
    'POLLS_TIME_REMAINING_DAYS_WEB.other': 'Endet in {days} Tagen',
    'POLLS_TIME_REMAINING_DAYS_WEB.zero': 'Endet heute',
    POLLS_VOTE_ERROR:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    'POLLS_VOTES_NUMBER_IOS.one': '1 Stimme',
    'POLLS_VOTES_NUMBER_IOS.other': '%d Stimmen',
    'POLLS_VOTES_NUMBER_IOS.zero': 'Keine Stimmen',
    'POLLS_VOTES_NUMBER_WEB.one': '1 Stimme',
    'POLLS_VOTES_NUMBER_WEB.other': '{votes} Stimmen',
    'POLLS_VOTES_NUMBER_WEB.zero': 'Keine Stimmen',
    SHARE_ACTIONSHEET_HEADER: 'Diesen Beitrag teilen',
    SHARE_BOX_DEFAULT_ERROR_MESSAGE:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    SHARE_BOX_HEADER: 'Auf XING teilen',
    SHARE_BOX_PLACEHOLDER: 'Hier kannst Du Deinen Link kommentieren.',
    SHARE_BOX_SHARE_SUCCESS: 'Vielen Dank fürs Teilen!',
    SHARE_BOX_SUBMIT_SHARE: 'Teilen',
    SHARE_BUTTON_LABEL: 'Teilen',
    SHARE_CANCEL_BUTTON: 'Abbrechen',
    SHARE_CHAT_CONTACTS: 'Kontakt auswählen',
    SHARE_CHAT_HINT: 'Die Empfänger erhalten einzelne Nachrichten.',
    SHARE_COUNTER_LABEL:
      '{counter, plural,\n    =1 {Einmal geteilt}\n    other {#-mal geteilt}\n}',
    SHARE_FEEDBACK_GROUPS_BUTTON: 'Beitrag ansehen',
    SHARE_FEEDBACK_GROUPS_MESSAGE: '{item} in der Gruppe {group} geteilt',
    SHARE_FEEDBACK_INSIDERARTICLE_LABEL: 'Artikel',
    SHARE_FEEDBACK_JOB_LABEL: 'Job',
    SHARE_FEEDBACK_KLARTEXT_LABEL: 'Beitrag',
    SHARE_FEEDBACK_LINK_LABEL: 'Link',
    SHARE_FEEDBACK_MESSENGER_BUTTON: 'Nachricht ansehen',
    SHARE_FEEDBACK_MESSENGER_MESSAGE: '{item} per XING Nachricht geteilt',
    SHARE_FEEDBACK_NEWS_LABEL: 'Artikel',
    SHARE_FEEDBACK_PICTURE_LABEL: 'Bild',
    SHARE_FEEDBACK_POST_LABEL: 'Beitrag',
    SHARE_FEEDBACK_STARTPAGE_BUTTON: 'Beitrag ansehen',
    SHARE_FEEDBACK_STARTPAGE_MESSAGE: '{item} auf der Startseite geteilt',
    SHARE_FEEDBACK_VIDEO_LABEL: 'Video',
    SHARE_FETCH_ERROR: 'Das hat leider nicht geklappt.',
    SHARE_FETCH_ERROR_COUNTDOWN:
      "Wir versuchen's in {countdown} Sekunden noch einmal.",
    SHARE_FETCH_ERROR_RETRY: 'Jetzt erneut versuchen',
    SHARE_MOST_RECENT_CHATS: 'Unterhaltungen',
    SHARE_PREVIEW_ERROR_HEADLINE:
      'Wir können gerade leider keine Vorschau zeigen.',
    SHARE_QUICKSHARE_TO_STARTPAGE: 'Direkt auf der Startseite',
    SHARE_TEXT_BOX_LENGTH_ERROR:
      '{delta, plural, \none {Bitte gib ein Zeichen weniger ein.} \nother {Bitte gib # Zeichen weniger ein.}\n}',
    SHARE_TO_GROUPS: 'In einer Gruppe',
    SHARE_TO_GROUPS_AUTOCOMPLETE_FORUMS: 'Forum',
    SHARE_TO_GROUPS_AUTOCOMPLETE_GROUPS: 'Gruppe',
    SHARE_TO_GROUPS_SELECTION_LABEL: 'Gruppe auswählen:',
    SHARE_TO_GROUPS_TEXT_PLACEHOLDER:
      'Hier kannst Du Deinen Link kommentieren.',
    SHARE_TO_GROUPS_THREAD_LABEL: 'Dein Gruppen-Beitrag:',
    SHARE_TO_GROUPS_TITLE_PLACEHOLDER: 'Beitragstitel',
    SHARE_TO_MESSENGER: 'Als private Nachricht',
    SHARE_TO_MESSENGER_EMPTY_STATE:
      'Wir haben leider keinen "{query}" gefunden.',
    SHARE_TO_STARTPAGE: 'Mit Anmerkung auf der Startseite',
    SHARE_USER_SUBTEXT_GROUPS: 'In einer Gruppe teilen',
    SHARE_USER_SUBTEXT_MESSAGE: 'Als private Nachricht teilen',
    SHARE_USER_SUBTEXT_STARTPAGE: 'Auf der Startseite teilen',
    SHARED_BUTTON_CONTINUE: 'Weiter',
    SHARER_LIST_HEADLINE_MEMBERS: '{total} Mitglieder haben dies geteilt.',
    SHARER_LIST_HEADLINE_MULTIPLE_MEMBERS:
      '{total} Mitglieder haben dies geteilt.',
    SHARER_LIST_HEADLINE_ONE_MEMBER: 'Ein Mitglied hat dies geteilt.',
    SHARER_LIST_ITEM_GO_TO_POST_LINK: 'Beitrag ansehen',
    SHARER_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.',
    SHARERS_BACK_TO_POST_LINK: 'Zurück',
    SHARERS_LIST_BACK_LINK: 'Zurück',
    SOCIAL_ADD_CONTACT: 'Kontakt-Anfrage schicken',
    SOCIAL_BAR_VIEW_COUNTER_DESCRIPTION:
      'Das zeigt Dir ab sofort immer der Zähler neben dem Augen-Symbol.',
    SOCIAL_BAR_VIEW_COUNTER_HEADING:
      'Wie oft wurde Dein Beitrag auf XING gesehen?',
    SOCIAL_BAR_VIEW_COUNTER_SEEN:
      'Dieser Beitrag von Dir wurde z. B. schon <strong>{views}-mal</strong> gesehen.',
    SOCIAL_BAR_VIEW_COUNTER_TIP:
      '<strong>Tipp:</strong> Mit ein paar Kniffen kannst Du <a>Deine Sichtbarkeit auf XING erhöhen</a>.',
    SOCIAL_COMMENT_BUTTON_LABEL: 'Kommentieren',
    SOCIAL_COMMENT_COUNTER_LABEL: '{amount} Kommentare',
    SOCIAL_COMMENT_CREATE_BUTTON_LABEL: 'Kommentieren',
    SOCIAL_COMMENT_DELETE_LABEL: 'Kommentar löschen',
    SOCIAL_COMMENT_DELETED_MESSAGE: 'Dieser Kommentar wurde gelöscht.',
    SOCIAL_COMMENT_EDIT_LABEL: 'Kommentar bearbeiten',
    SOCIAL_COMMENT_ERROR_TOO_LARGE:
      'Dieser Kommentar ist leider zu lang: Bis zu 20 Tsd. Zeichen sind erlaubt.',
    SOCIAL_COMMENT_LIST_EMPTY_HEADLINE: 'Und was meinst Du dazu?',
    SOCIAL_COMMENT_LIST_EMPTY_SUBLINE: 'Verrate uns Deine Meinung.',
    SOCIAL_COMMENT_OVERFLOW_ERROR: '{amount} Zeichen',
    SOCIAL_COMMENT_REPORT_LABEL: 'Kommentar melden',
    SOCIAL_COMMENT_WAS_EDITED: 'Bearbeitet',
    SOCIAL_COMMENTS_COUNTER_LABEL:
      "{counter, plural,\n    =0 {Kommentier's als erstes:}\n    =1 {1 Kommentar} \n    other {# Kommentare}\n}",
    SOCIAL_COMMENTS_CREATE_MENTION_PLACEHOLDER:
      'Etwas schreiben (andere mit "@" erwähnen) …',
    SOCIAL_COMMENTS_CREATE_PLACEHOLDER: 'Schreibe einen Kommentar …',
    SOCIAL_COMMENTS_DELETE_DIALOG_CANCEL: 'Abbrechen',
    SOCIAL_COMMENTS_DELETE_DIALOG_CONFIRM: 'Löschen',
    SOCIAL_COMMENTS_DELETE_DIALOG_CREATOR_TEXT:
      'Nicht zufrieden mit Deinem Kommentar? Dann kannst Du ihn einfach löschen.',
    SOCIAL_COMMENTS_DELETE_DIALOG_HEADLINE: 'Kommentar löschen?',
    SOCIAL_COMMENTS_DELETE_DIALOG_TEXT:
      'Dies kann nicht mehr rückgängig gemacht werden.',
    SOCIAL_COMMENTS_DELETE_MENTION_LABEL: 'Nicht erwähnt werden',
    SOCIAL_COMMENTS_DELETED_TEXT: 'Dieser Kommentar wurde gelöscht.',
    SOCIAL_COMMENTS_ERROR:
      "Das hat leider nicht geklappt. Probier's bitte nochmal.",
    SOCIAL_COMMENTS_FORM_PLACEHOLDER: 'Etwas schreiben ( mit "@" erwähnen) …',
    SOCIAL_COMMENTS_LOAD_MORE: 'Weitere Kommentare',
    SOCIAL_COMMENTS_MORE_REPLIES: 'Weitere Antworten ansehen',
    SOCIAL_COMMENTS_PREVIOUS_COMMENTS: 'Vorherige Kommentare ansehen',
    SOCIAL_COMMENTS_PREVIOUS_REPLIES: 'Vorherige Antworten ansehen',
    SOCIAL_COMMENTS_REPLY_PLACEHOLDER: 'Deine Antwort an {authorName}',
    SOCIAL_GENERIC_REPORT: 'Melden',
    SOCIAL_INTERACTION_BAR_COMMENT_INPUT_HINT: 'Etwas schreiben ...',
    SOCIAL_LIKERS_LIST_HEADLINE: 'Diesen Mitgliedern gefällt das:',
    SOCIAL_LIKERS_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle "Gefällt mir"-Angaben sehen, weil einige Mitglieder das in ihren Privatsphäre-Einstellungen so festgelegt haben.',
    SOCIAL_LOAD_MORE_BUTTON: 'Weitere Kommentare',
    SOCIAL_OK: 'Alles klar',
    SOCIAL_PMBX_COMMENT_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_COMMENT_DATE: 'Datum',
    SOCIAL_PMBX_COMMENT_HEADING: 'Deine Kommentare und Antworten',
    SOCIAL_PMBX_COMMENT_MESSAGE: 'Dein Kommentar',
    SOCIAL_PMBX_COMMENT_ORIGIN: 'Wo hast Du kommentiert?',
    SOCIAL_PMBX_COMMENT_TITLE: 'Deine Kommentare und Antworten',
    SOCIAL_PMBX_COMMENT_USER_AGENT: 'System-Info',
    SOCIAL_PMBX_DESCRIPTION:
      'Beiträge auf XING, die Du geteilt, kommentiert, erwähnt oder mit "Gefällt mir" markiert hast',
    SOCIAL_PMBX_MENTION_DOCUMENT_URL: 'Inhalt',
    SOCIAL_PMBX_MENTION_HEADING: 'Deine Erwähnungen',
    SOCIAL_PMBX_MENTION_TITLE: 'Deine Erwähnungen',
    SOCIAL_PMBX_REACTION_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_REACTION_DATE: 'Datum',
    SOCIAL_PMBX_REACTION_LIKE: 'Beiträge, die Dir gefallen.',
    SOCIAL_PMBX_REACTION_ORIGIN: 'Wo hast Du auf den Beitrag reagiert?',
    SOCIAL_PMBX_REACTION_TITLE: 'Beiträge, auf die Du reagiert hast',
    SOCIAL_PMBX_REACTION_USER_AGENT: 'User Agent',
    SOCIAL_PMBX_SHARE_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_SHARE_DATE: 'Datum',
    SOCIAL_PMBX_SHARE_GROUPS: 'Beiträge, die Du in einer Gruppe geteilt hast',
    SOCIAL_PMBX_SHARE_MESSAGE: 'Deine Anmerkung',
    SOCIAL_PMBX_SHARE_MESSENGER:
      'Beiträge, die Du als private Nachricht geteilt hast',
    SOCIAL_PMBX_SHARE_ORIGIN: 'Wo hast Du den Beitrag geteilt?',
    SOCIAL_PMBX_SHARE_STARTPAGE:
      'Beiträge, die Du auf der XING Startseite geteilt hast',
    SOCIAL_PMBX_SHARE_TITLE: 'Beiträge, die Du geteilt hast',
    SOCIAL_PMBX_SHARE_USER_AGENT: 'User Agent',
    SOCIAL_PMBX_TITLE: 'Interaktionen',
    SOCIAL_REPLIES_LOAD_MORE: 'Weitere Antworten ansehen',
    SOCIAL_REPLY_BUTTON: 'Antworten',
    SOCIAL_REPLY_DISCARD_MESSAGE:
      'Dann kannst Du ihn löschen. Vielleicht schreibst Du ja beim nächsten Mal was.',
    SOCIAL_REPLY_LOAD_MORE: 'Weitere Antwort ansehen',
    SOCIAL_REPLY_LOAD_MULTIPLE: 'Weitere Kommentare ansehen',
    SOCIAL_REPLY_POST_BUTTON: 'Antworten',
    SOCIAL_SEND_MESSAGE: 'Nachricht schreiben',
    SOCIAL_SHARE_COUNTER_LABEL: '{amount}-mal geteilt',
    SOCIAL_SHARE_EXTERNAL_LINK_ERROR:
      'Dieser Link funktioniert leider nicht – deshalb kannst Du ihn nicht teilen.',
    SOCIAL_SHARERS_LIST_HEADLINE_MEMBERS: 'Diese Mitglieder haben das geteilt:',
    SOCIAL_SHARERS_LIST_ITEM_GO_TO_POST_LINK: 'Beitrag ansehen',
    SOCIAL_SHARERS_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.',
    SOCIAL_SHOW_MORE: 'Weiterlesen',
    SOCIAL_SOCIAL_PROOF_LABEL:
      '{counter, plural,\n    =1 {gefällt das:}\n    other {# gefällt das:}\n}',
    SOCIAL_UPDATE_COMMENT_LABEL: 'Speichern',
    TOP_ARTICLE_PAID_COPY:
      'Heften Sie Ihre Top-Artikel an und wechseln Sie diese bei Bedarf, sodass der aktuell wichtigste Beitrag immer an oberster Stelle bei Ihren Neuigkeiten erscheint.',
    TOP_ARTICLE_PAID_CTA: 'Alle Vorteile entdecken',
    TOP_ARTICLE_PAID_FLAG: 'Employer Branding Profil',
    TOP_ARTICLE_PAID_HEADLINE: 'Was steht für Sie an erster Stelle?',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL: 'Zurück',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL_CUSTOM: 'Zurück zu {section}',
    TOP_BAR_ME_MENU_DIMMER_ARIA_LABEL: 'MeMenü schließen',
    TOP_BAR_PROFILE_FILLING_INDICATOR_TITLE: 'Profil',
    XDS_FLAG_AMBASSADOR_DIVERSE: 'Ambassadx',
    XDS_FLAG_AMBASSADOR_FEMALE: 'Ambassadorin',
    XDS_FLAG_AMBASSADOR_MALE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_NEUTRAL: 'Ambassador',
    XDS_FLAG_BASIC_DIVERSE: 'Basis',
    XDS_FLAG_BASIC_FEMALE: 'Basis',
    XDS_FLAG_BASIC_MALE: 'Basis',
    XDS_FLAG_BASIC_NEUTRAL: 'Basis',
    XDS_FLAG_BETA_DIVERSE: 'Beta',
    XDS_FLAG_BETA_FEMALE: 'Beta',
    XDS_FLAG_BETA_MALE: 'Beta',
    XDS_FLAG_BETA_NEUTRAL: 'Beta',
    XDS_FLAG_INSIDER_DIVERSE: 'Insidx',
    XDS_FLAG_INSIDER_FEMALE: 'Insiderin',
    XDS_FLAG_INSIDER_MALE: 'Insider',
    XDS_FLAG_INSIDER_NEUTRAL: 'Insider',
    XDS_FLAG_MODERATOR_DIVERSE: 'Moderatx',
    XDS_FLAG_MODERATOR_FEMALE: 'Moderatorin',
    XDS_FLAG_MODERATOR_MALE: 'Moderator',
    XDS_FLAG_MODERATOR_NEUTRAL: 'Moderator',
    XDS_FLAG_NEW_DIVERSE: 'Neu',
    XDS_FLAG_NEW_FEMALE: 'Neu',
    XDS_FLAG_NEW_MALE: 'Neu',
    XDS_FLAG_NEW_NEUTRAL: 'Neu',
    XDS_FLAG_PREMIUM_DIVERSE: 'Premium',
    XDS_FLAG_PREMIUM_FEMALE: 'Premium',
    XDS_FLAG_PREMIUM_MALE: 'Premium',
    XDS_FLAG_PREMIUM_NEUTRAL: 'Premium',
    XDS_FLAG_PROBUSINESS_DIVERSE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_FEMALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_MALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_NEUTRAL: 'ProBusiness',
    XDS_FLAG_PROCOACH_DIVERSE: 'ProCoach',
    XDS_FLAG_PROCOACH_FEMALE: 'ProCoach',
    XDS_FLAG_PROCOACH_MALE: 'ProCoach',
    XDS_FLAG_PROCOACH_NEUTRAL: 'ProCoach',
    XDS_FLAG_PROJOBS_DIVERSE: 'ProJobs',
    XDS_FLAG_PROJOBS_FEMALE: 'ProJobs',
    XDS_FLAG_PROJOBS_MALE: 'ProJobs',
    XDS_FLAG_PROJOBS_NEUTRAL: 'ProJobs',
    XDS_FLAG_PROTRAINER_DIVERSE: 'ProTrainx',
    XDS_FLAG_PROTRAINER_FEMALE: 'ProTrainerin',
    XDS_FLAG_PROTRAINER_MALE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_NEUTRAL: 'ProTrainer',
    XING_FAQ_GUIDE_URL:
      'https://help.xing.com/hc/de/articles/33816993574801-Netzwerken-so-geht-s?segment=b2c ',
  },
};
